#
msgid ""
msgstr ""
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2026-03-27 14:00+0200\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: th\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: \n"
"X-Generator: @lingui/cli\n"

#. placeholder {0}: item.maxSurge
#. placeholder {0}: item.maximum
#. placeholder {0}: item.minimum
#. placeholder {1}: item.maxSurge
#. placeholder {1}: item.maximum
#. placeholder {1}: item.minimum
#: src/modules/services/FailoverNodeSelect.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "{0} {1, plural, one {node} other {nodes}}"
msgstr "{0} {1, plural, one {โหนด} other {โหนด}}"

#. placeholder {0}: uploadStats.uploadedFiles
#. placeholder {1}: uploadStats.totalFiles
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{0} of {1} files uploaded"
msgstr "อัปโหลดแล้ว {0} จาก {1} ไฟล์"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{name} will be deleted permanently."
msgstr "{name} จะถูกลบอย่างถาวร"

#: src/modules/storage/StorageList.tsx
msgid "{number_of_buckets, plural, one {bucket} other {buckets}}"
msgstr "{number_of_buckets, plural, one {บัคเก็ต} other {บัคเก็ต}}"

#. {resourceTypeName} is eg. 'virtual machine' or 'billing account'
#: src/modules/api/resourceTypeException.tsx
msgid "{resourceTypeName} with ID {id} not found"
msgstr "ไม่พบ{resourceTypeName} ที่มี ID {id}"

#. ONLY:bn
#: src/styles/tenbyte/theme.tsx
msgid "<0><1>Individual/Proprietor: NID, Passport, or Driver's License.</1><2>Company/Corporate: Trade License.</2><3>Financial & Legal: Tax Identification Number (TIN), VAT Certificate.</3></0>"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "1 bare metal server"
msgstr "เซิร์ฟเวอร์ Bare Metal 1 เครื่อง"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 day"
msgstr "1 วัน"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 hour"
msgstr "1 ชั่วโมง"

#: src/modules/billing/omise/OmisePaymentForm.tsx
msgid "10 digit TrueMoney mobile number starting with 0"
msgstr "หมายเลขโทรศัพท์มือถือ TrueMoney 10 หลักที่ขึ้นต้นด้วย 0"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "3 days"
msgstr "3 วัน"

#: src/modules/compute/VmView.tsx
msgid "4 weeks"
msgstr "4 สัปดาห์"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "6 hours"
msgstr "6 ชั่วโมง"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "7 days"
msgstr "7 วัน"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "A discount has been applied for all services under this billing account."
msgstr "มีการใช้ส่วนลดกับบริการทั้งหมดภายใต้บัญชีการเรียกเก็บเงินนี้"

#: src/modules/compute/VmCreate.tsx
msgid "A user account will be created with this username. It can be used to log in to the VM. Can contain ASCII letters, digits, underscores and hyphens. Must start with a letter or underscore. Maximum length is 25 characters."
msgstr "จะมีการสร้างบัญชีผู้ใช้ด้วยชื่อผู้ใช้นี้ ซึ่งสามารถใช้เข้าสู่ระบบ VM ได้ โดยใช้ได้เฉพาะตัวอักษร ASCII ตัวเลข ขีดล่าง และขีดกลางเท่านั้น และต้องขึ้นต้นด้วยตัวอักษรหรือขีดล่าง ความยาวสูงสุดคือ 25 อักขระ"

#: src/modules/network/NetworkCreate.tsx
msgid "A virtual private cloud (VPC) is a private network interface for collections of your resources. VPC network is available at no additional cost."
msgstr "Virtual Private Cloud (VPC) คืออินเทอร์เฟซเครือข่ายส่วนตัวสำหรับกลุ่มทรัพยากรของคุณ เครือข่าย VPC พร้อมให้ใช้งานโดยไม่มีค่าใช้จ่ายเพิ่มเติม"

#: src/modules/access/AcceptInvitationModal.tsx
#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept"
msgstr "ยอมรับ"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept invitation"
msgstr "ยอมรับคำเชิญ"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/user/ProfileView.tsx
msgid "Accepted"
msgstr "ยอมรับแล้ว"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accepting this access invitation will grant you permission to act as \"{name}\" and perform all operations on behalf of the user."
msgstr "การยอมรับคำเชิญให้เข้าถึงนี้จะให้สิทธิ์แก่คุณในการดำเนินการในนามของ \"{name}\" และดำเนินการทั้งหมดแทนผู้ใช้รายนั้น"

#. Label for dropdown menu that has options related to file sharing and permissions. | POS: Noun
#. Title for section that contains credentials to connect to a database
#: src/modules/access/AccessList.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/Access.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Access"
msgstr "การเข้าถึง"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Access credentials"
msgstr "ข้อมูลรับรองการเข้าถึง"

#: src/modules/api/resourceTypes.tsx
msgid "Access delegation"
msgstr "การมอบสิทธิ์การเข้าถึง"

#: src/modules/user/ProfileView.tsx
msgid "Access group"
msgstr "กลุ่มสิทธิ์การเข้าถึง"

#: src/modules/user/InvitationNotice.tsx
msgid "Access has been shared with you"
msgstr "มีการแชร์สิทธิ์การเข้าถึงให้คุณ"

#: src/modules/api/resourceTypes.tsx
msgid "Access invitation"
msgstr "คำเชิญการเข้าถึง"

#. placeholder {0}: item.access_owner
#: src/modules/user/InvitationNotice.tsx
msgid "Access invitation from {0} is pending"
msgstr "คำเชิญสิทธิ์การเข้าถึงจาก {0} กำลังรอดำเนินการ"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Access key ID"
msgstr "รหัสคีย์การเข้าถึง"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access name"
msgstr "ชื่อการเข้าถึง"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Access scope"
msgstr "ขอบเขตการเข้าถึง"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access type"
msgstr "ประเภทการเข้าถึง"

#. Dialog title
#: src/modules/user/ActAsModal.tsx
msgid "Access user"
msgstr "เข้าถึงผู้ใช้"

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
#: src/modules/billing/NoValidBillingAccountNotice.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account details are being validated."
msgstr "กำลังตรวจสอบรายละเอียดบัญชี"

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "Account details must be validated"
msgstr "ต้องตรวจสอบรายละเอียดบัญชี"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Account ID"
msgstr "รหัสบัญชี"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account name"
msgstr "ชื่อบัญชี"

#. Menu item to impersonate another user
#: src/modules/user/ActAsModal.tsx
#: src/modules/user/UserMenu.tsx
msgid "Act as"
msgstr "ดำเนินการในนาม"

#. placeholder {0}: impersonation.access_owner
#: src/modules/user/ImpersonateTopItem.tsx
msgid "Acting as <0>{0}</0>"
msgstr "กำลังใช้งานในนาม <0>{0}</0>"

#. Login page title when email verification is required
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Action required"
msgstr "ต้องดำเนินการ"

#. Disk status
#. Service status
#: src/modules/compute/statusLabels.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Active"
msgstr "ใช้งานอยู่"

#: src/modules/storage/StorageCreate.tsx
msgid "Actual cost of your storage is calculated hourly based on your actual usage, no upfront payments. For every started GB the price is rounded up to next whole GB."
msgstr "ค่าใช้จ่ายจริงของพื้นที่จัดเก็บของคุณจะคำนวณเป็นรายชั่วโมงตามการใช้งานจริง โดยไม่ต้องชำระล่วงหน้า และทุก GB ที่เริ่มใช้งานจะถูกปัดราคาขึ้นเป็น GB เต็มถัดไป"

#: src/modules/services/ServiceView.tsx
msgid "Actual price is determined by compute and storage usage. Persistent volumes of hibernated clusters will still be charged for. See billing account current usage for more detailed information."
msgstr "ราคาจริงจะขึ้นอยู่กับการใช้งานทรัพยากรประมวลผลและพื้นที่จัดเก็บข้อมูล โวลุ่มถาวรของคลัสเตอร์ที่ไฮเบอร์เนตแล้วจะยังคงมีการเรียกเก็บเงิน ดูการใช้งานปัจจุบันของบัญชีการเรียกเก็บเงินเพื่อดูข้อมูลเพิ่มเติม"

#. Add a new row; Button action
#: src/components/EditableList.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add"
msgstr "เพิ่ม"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Add a a payment method that supports automated top up."
msgstr "เพิ่มวิธีการชำระเงินที่รองรับการเติมเงินอัตโนมัติ"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Add additional disk"
msgstr "เพิ่มดิสก์เพิ่มเติม"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one forwarding rule"
msgstr "เพิ่มกฎการส่งต่ออย่างน้อยหนึ่งข้อ"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one target server"
msgstr "เพิ่มเซิร์ฟเวอร์เป้าหมายอย่างน้อยหนึ่งรายการ"

#: src/modules/compute/VmCreate.tsx
msgid "Add custom configuration for the virtual machine"
msgstr "เพิ่มการกำหนดค่าแบบกำหนดเองสำหรับเครื่องเสมือน"

#: src/modules/user/ProfileView.tsx
msgid "Add first name"
msgstr "เพิ่มชื่อ"

#: src/modules/services/IpWhitelist.tsx
msgid "Add IP"
msgstr "เพิ่ม IP"

#: src/modules/user/ProfileView.tsx
msgid "Add last name"
msgstr "เพิ่มนามสกุล"

#: src/components/table/DetailsTableName.tsx
msgid "Add name"
msgstr "เพิ่มชื่อ"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add new payment method..."
msgstr "เพิ่มวิธีการชำระเงินใหม่..."

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Add new reservation"
msgstr "เพิ่มการจองใหม่"

#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add new rule"
msgstr "เพิ่มกฎใหม่"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add node"
msgstr "เพิ่มโหนด"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Add node pool"
msgstr "เพิ่ม Node pool"

#: src/modules/billing/ActionButtons.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add payment method"
msgstr "เพิ่มวิธีการชำระเงิน"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Add payment method later"
msgstr "เพิ่มวิธีชำระเงินภายหลัง"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "Add rule"
msgstr "เพิ่มกฎ"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Add SSH key"
msgstr "เพิ่มคีย์ SSH"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Add sub-interface"
msgstr "เพิ่มอินเทอร์เฟซย่อย"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add target server"
msgstr "เพิ่มเซิร์ฟเวอร์เป้าหมาย"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "Add user"
msgstr "เพิ่มผู้ใช้"

#: src/modules/access/delegation/DelegationView.tsx
msgid "Add users"
msgstr "เพิ่มผู้ใช้"

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Adding payment method failed"
msgstr "เพิ่มวิธีการชำระเงินไม่สำเร็จ"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/network/NetworkList.tsx
msgid "Address"
msgstr "ที่อยู่"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Address line 2"
msgstr "ที่อยู่บรรทัดที่ 2"

#. Link to administrative user interface
#: src/modules/user/UserMenu.tsx
msgid "Admin view"
msgstr "มุมมองผู้ดูแลระบบ"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/WTabs.tsx
msgid "All"
msgstr "ทั้งหมด"

#. A firewall rule that applies to every source or destination IP address
#: src/modules/network/firewall/firewallLabels.tsx
msgid "All IP addresses"
msgstr "ที่อยู่ IP ทั้งหมด"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "All permissions"
msgstr "สิทธิ์ทั้งหมด"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All TCP"
msgstr "TCP ทั้งหมด"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All UDP"
msgstr "UDP ทั้งหมด"

#: src/modules/api/resourceTypes.tsx
msgid "Allocate a floating IP and start managing your network."
msgstr "จัดสรรไอพีลอยตัวและเริ่มจัดการเครือข่ายของคุณ"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Allocated"
msgstr "จัดสรรแล้ว"

#: src/modules/network/NetworkCreate.tsx
msgid "Allocating a new IPv4 address allows you to assign it to one of your existing resources or reserve it for later use."
msgstr "การจัดสรรที่อยู่ IPv4 ใหม่ช่วยให้คุณกำหนดให้กับทรัพยากรที่มีอยู่ของคุณ หรือสำรองไว้เพื่อใช้งานภายหลังได้"

#: src/modules/login/Login.tsx
msgid "Already have an account?"
msgstr "มีบัญชีอยู่แล้วหรือไม่?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Amount"
msgstr "จำนวนเงิน"

#. Field label for reservation upfront cost
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Amount billed upfront"
msgstr "จำนวนเงินที่เรียกเก็บล่วงหน้า"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Amount is too low"
msgstr "จำนวนเงินต่ำเกินไป"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Amount should be positive"
msgstr "จำนวนเงินต้องมากกว่า 0"

#: src/modules/billing/AutomatedTopUpModal.tsx
msgid "Amount should not be less than than minimum top up"
msgstr "จำนวนเงินต้องไม่น้อยกว่ายอดเติมเงินขั้นต่ำ"

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "An active billing account is needed to create resources."
msgstr "จำเป็นต้องมีบัญชีการเรียกเก็บเงินที่ใช้งานอยู่เพื่อสร้างทรัพยากร"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "An active billing account is needed to use this feature."
msgstr "จำเป็นต้องมีบัญชีการเรียกเก็บเงินที่ใช้งานอยู่เพื่อใช้ฟีเจอร์นี้"

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
msgid "An e-mail with instructions has been sent to you."
msgstr "อีเมลพร้อมคำแนะนำได้ถูกส่งถึงคุณแล้ว"

#: src/components/modal/WModal.tsx
#: src/components/sidebar/ListErrorBoundary.tsx
msgid "An error happened"
msgstr "เกิดข้อผิดพลาด"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/firewall/ruleSpec.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Any"
msgstr "ใดก็ได้"

#: src/modules/access/AccessList.tsx
#: src/modules/dashboard/WelcomeBlock.tsx
#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "API"
msgstr "API"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "API documentation"
msgstr "เอกสาร API"

#: src/modules/api/resourceTypes.tsx
msgid "API token"
msgstr "โทเค็น API"

#: src/modules/compute/labels.tsx
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "App catalog"
msgstr "แค็ตตาล็อกแอป"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Appearance"
msgstr "การแสดงผล"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Apply for payment by invoice"
msgstr "ขอใช้การชำระด้วยใบแจ้งหนี้"

#: src/modules/compute/SubInterfaceDeleteModal.tsx
msgid "Are you sure you want to delete sub-interface with uuid {ifUuid}?"
msgstr "คุณแน่ใจหรือไม่ว่าต้องการลบอินเทอร์เฟซย่อยที่มี UUID {ifUuid}?"

#: src/modules/compute/SshKeyDeleteModal.tsx
msgid "Are you sure you want to delete the public key \"{name}\"?"
msgstr "คุณแน่ใจหรือไม่ว่าต้องการลบกุญแจสาธารณะ \"{name}\"?"

#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Are you sure you want to log out?"
msgstr "คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบ?"

#: src/modules/network/NetworkCreate.tsx
msgid "Assign to"
msgstr "กำหนดให้กับ"

#. State of IP address, attached to a resource such as a virtual machine
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
msgid "Assigned"
msgstr "กำหนดแล้ว"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Assigned to"
msgstr "กำหนดให้กับ"

#: src/modules/access/AccessCreate.tsx
msgid "At least one email is required"
msgstr "ต้องระบุอีเมลอย่างน้อยหนึ่งรายการ"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "At least one IP is required"
msgstr "ต้องระบุ IP อย่างน้อยหนึ่งรายการ"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "At least one node pool must have autoscaler minimum value as 1 or more."
msgstr "ต้องมี Node pool อย่างน้อยหนึ่งรายการที่มีค่าต่ำสุดของ Autoscaler เท่ากับ 1 หรือมากกว่า"

#: src/modules/compute/VmView.tsx
msgid "Attach firewall"
msgstr "แนบไฟร์วอลล์"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Attach resource"
msgstr "เชื่อมต่อทรัพยากร"

#: src/modules/disks/DiskList.tsx
msgid "Attached"
msgstr "เชื่อมต่อแล้ว"

#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
msgid "Attached to"
msgstr "เชื่อมต่อกับ"

#. Explanation: Switching the color schema automatically. |Alternatives: 'Automatic'
#: src/modules/main/ColorSchemeMenu.tsx
msgid "Auto"
msgstr "อัตโนมัติ"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Auto update"
msgstr "อัปเดตอัตโนมัติ"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Automated payment"
msgstr "การชำระเงินอัตโนมัติ"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automated top up"
msgstr "การเติมเงินอัตโนมัติ"

#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your service. Backups will be stored for 7 days, meaning you will have 7 latest backups."
msgstr "เปิดใช้งานการสำรองข้อมูลอัตโนมัติในระดับระบบแล้ว คุณสามารถใช้อิมเมจสำรองข้อมูลเพื่อกู้คืนบริการของคุณได้ โดยระบบจะจัดเก็บข้อมูลสำรองไว้เป็นเวลา 7 วัน ซึ่งหมายความว่าคุณจะมีข้อมูลสำรองล่าสุด 7 ชุด"

#: src/modules/compute/VmView.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your virtual machine or create a new virtual machine from the backup with modified size parameters."
msgstr "เปิดใช้การสำรองข้อมูลระดับระบบอัตโนมัติแล้ว ใช้อิมเมจสำรองเพื่อกู้คืนเครื่องเสมือนของคุณ หรือสร้างเครื่องเสมือนใหม่จากข้อมูลสำรองโดยปรับเปลี่ยนพารามิเตอร์ขนาด"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Automatic updates will not update preview versions."
msgstr "การอัปเดตอัตโนมัติจะไม่อัปเดตเวอร์ชันพรีวิว"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automatically top up (min. <0/>)"
msgstr "เติมเงินอัตโนมัติ (ขั้นต่ำ <0/>)"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler max."
msgstr "ค่าสูงสุดของ Autoscaler"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler min."
msgstr "ค่าต่ำสุดของ Autoscaler"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Available"
msgstr "พร้อมให้ใช้งาน"

#: src/modules/services/ServiceView.tsx
msgid "Awake"
msgstr "ทำงานอยู่"

#. Button action
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Back"
msgstr "ย้อนกลับ"

#: src/modules/user/ImpersonateTopItem.tsx
#: src/modules/user/UserMenu.tsx
msgid "Back to your account"
msgstr "กลับไปยังบัญชีของคุณ"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
msgid "Backups"
msgstr "ข้อมูลสำรอง"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance history"
msgstr "ประวัติยอดคงเหลือ"

#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/metal/MetalList.tsx
msgid "Bare metal"
msgstr "Bare Metal"

#: src/modules/api/resourceTypes.tsx
msgid "Bare metal server"
msgstr "เซิร์ฟเวอร์ Bare Metal"

#: src/modules/billing/BaseCurrencyField.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Base currency"
msgstr "สกุลเงินหลัก"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Begin your billing account validation process."
msgstr "เริ่มกระบวนการยืนยันบัญชีการเรียกเก็บเงินของคุณ"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Below is an example of how to configure this sub-interface on a Linux server."
msgstr "ด้านล่างนี้เป็นตัวอย่างวิธีตั้งค่าอินเทอร์เฟซย่อยนี้บนเซิร์ฟเวอร์ Linux"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Billed"
msgstr "เรียกเก็บเงินแล้ว"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Billing"
msgstr "การเรียกเก็บเงิน"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/table/DetailsTableBillingAccount.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/forms/BillingAccountField.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Billing account"
msgstr "บัญชีการเรียกเก็บเงิน"

#. Price list annotation
#: src/modules/pricing/PricingModal.tsx
msgid "Billing account \"{title}\" has discount {discount_percentage}%"
msgstr "บัญชีการเรียกเก็บเงิน \"{title}\" ได้รับส่วนลด {discount_percentage}%"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Billing account is limited"
msgstr "บัญชีการเรียกเก็บเงินถูกจำกัด"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Billing account name"
msgstr "ชื่อบัญชีการเรียกเก็บเงิน"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Billing account override"
msgstr "การแทนที่บัญชีเรียกเก็บเงิน"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Billing account suspended"
msgstr "บัญชีการเรียกเก็บเงินถูกระงับ"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Billing account validation was rejected"
msgstr "การยืนยันบัญชีเรียกเก็บเงินถูกปฏิเสธ"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Billing accounts"
msgstr "บัญชีการเรียกเก็บเงิน"

#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Billing cycle"
msgstr "รอบการเรียกเก็บเงิน"

#: src/modules/disks/disk/DiskView.tsx
msgid "Boot"
msgstr "บูต"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Boot from ISO medium"
msgstr "บูตจากสื่อ ISO"

#. Virtual machine choice: UEFI or BIOS
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Boot mode"
msgstr "โหมดการบูต"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Booting is only possible when the virtual machine is stopped."
msgstr "การบูตทำได้เฉพาะเมื่อเครื่องเสมือนหยุดทำงานอยู่เท่านั้น"

#. {payment method} provided by {payment gateway name}
#: src/modules/billing/utils.tsx
msgid "by {gatewayName}"
msgstr "โดย {gatewayName}"

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "By continuing with the top up you agree to the <0>Terms & Conditions</0>, <1>Privacy Policy</1> & <2>Refund Policy</2>."
msgstr "เมื่อดำเนินการเติมเงินต่อไป ถือว่าคุณยอมรับ<0>ข้อกำหนดและเงื่อนไข</0> <1>นโยบายความเป็นส่วนตัว</1> และ <2>นโยบายการคืนเงิน</2>"

#: src/modules/compute/VmView.tsx
msgid "By disabling backups there will not be any further automatic backups made from your virtual machine. Backups done by this point will be kept as is and you can still use them. You can enable backups again whenever needed."
msgstr "เมื่อปิดการสำรองข้อมูล จะไม่มีการสร้างข้อมูลสำรองอัตโนมัติจากเครื่องเสมือนของคุณอีกต่อไป ข้อมูลสำรองที่มีอยู่แล้วจะยังคงถูกเก็บไว้ตามเดิมและยังสามารถใช้งานได้ คุณสามารถเปิดการสำรองข้อมูลอีกครั้งได้ทุกเมื่อเมื่อจำเป็น"

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Global”, all resources under this user account can be accessed. Exercise caution when selecting “Global” scope."
msgstr "เมื่อเลือก “ทั่วทั้งบัญชี” จะสามารถเข้าถึงทรัพยากรทั้งหมดภายใต้บัญชีผู้ใช้นี้ได้ โปรดใช้ความระมัดระวังเมื่อเลือกขอบเขต “ทั่วทั้งบัญชี”"

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Restricted”, access will be limited to resources belonging to the selected billing account."
msgstr "เมื่อเลือก “จำกัด” การเข้าถึงจะถูกจำกัดไว้เฉพาะทรัพยากรที่อยู่ในบัญชีการเรียกเก็บเงินที่เลือก"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "By signing up, you agree to the <0>Terms of Service</0>"
msgstr "เมื่อสมัครสมาชิก แสดงว่าคุณยอมรับ<0>ข้อกำหนดในการให้บริการ</0>"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Campaign code"
msgstr "รหัสแคมเปญ"

#: src/modules/dashboard/UserAccess.tsx
msgid "Can access me"
msgstr "เข้าถึงฉันได้"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Cancel"
msgstr "ยกเลิก"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Cancel uploads"
msgstr "ยกเลิกการอัปโหลด"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Cancelled"
msgstr "ยกเลิกแล้ว"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Card number"
msgstr "หมายเลขบัตร"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Card verification failed"
msgstr "การยืนยันบัตรล้มเหลว"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change"
msgstr "เปลี่ยน"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change password"
msgstr "เปลี่ยนรหัสผ่าน"

#: src/modules/login/Login.tsx
msgid "Change your password by clicking the verification link we just sent to your inbox."
msgstr "เปลี่ยนรหัสผ่านของคุณโดยคลิกลิงก์ยืนยันที่เราเพิ่งส่งไปยังกล่องจดหมายของคุณ"

#: src/modules/user/ProfileView.tsx
msgid "Changing the password failed"
msgstr "เปลี่ยนรหัสผ่านไม่สำเร็จ"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Changing the password is only possible when the virtual machine is running."
msgstr "การเปลี่ยนรหัสผ่านทำได้เฉพาะเมื่อเครื่องเสมือนกำลังทำงานอยู่เท่านั้น"

#: src/modules/billing/forms/BillingAccountField.tsx
msgid "Choose a billing account for your new resource to consolidate your resources under a suitable payment method."
msgstr "เลือกบัญชีการเรียกเก็บเงินสำหรับทรัพยากรใหม่ของคุณ เพื่อรวมทรัพยากรไว้ภายใต้วิธีการชำระเงินที่เหมาะสม"

#: src/modules/access/AccessCreate.tsx
msgid "Choose a billing account you wish to share access to"
msgstr "เลือกบัญชีการเรียกเก็บเงินที่คุณต้องการแบ่งปันการเข้าถึง"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose a resource to assign the IP to or leave it unassigned. You can always assign the IP to a suitable resource later"
msgstr "เลือกทรัพยากรที่จะกำหนด IP ให้ หรือปล่อยไว้โดยยังไม่กำหนดก็ได้ คุณสามารถกำหนด IP ให้กับทรัพยากรที่เหมาะสมในภายหลังได้เสมอ"

#: src/modules/disks/DiskCreate.tsx
msgid "Choose a virtual machine to attach the disk to, or leave it detached and connect it to a virtual machine later."
msgstr "เลือกเครื่องเสมือนที่จะเชื่อมต่อดิสก์ หรือปล่อยให้ดิสก์ยังไม่เชื่อมต่อแล้วค่อยเชื่อมต่อกับเครื่องเสมือนภายหลัง"

#: src/modules/compute/VmCreate.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "Choose a VPC network for your resource from already existing one or create a new private network."
msgstr "เลือกเครือข่าย VPC สำหรับทรัพยากรของคุณจากเครือข่ายที่มีอยู่แล้ว หรือสร้างเครือข่ายส่วนตัวใหม่"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Choose billing account"
msgstr "เลือกบัญชีการเรียกเก็บเงิน"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Choose method"
msgstr "เลือกวิธี"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose the VPC network the target servers are in."
msgstr "เลือกเครือข่าย VPC ที่เซิร์ฟเวอร์เป้าหมายอยู่"

#: src/modules/compute/VmCreate.tsx
msgid "Choose UEFI if the VM you are importing requires it."
msgstr "เลือก UEFI หาก VM ที่คุณกำลังนำเข้าต้องใช้"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "City"
msgstr "เมือง"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Cleaning"
msgstr "กำลังล้างข้อมูล"

#: src/modules/notifications/NotificationMenu.tsx
msgid "Clear all"
msgstr "ล้างทั้งหมด"

#. Button: Remove the over-ride of the billing account for this bucket
#: src/modules/storage/bucket/BucketView.tsx
msgid "Clear override"
msgstr "ล้างการแทนที่"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Clear uploads"
msgstr "ล้างรายการอัปโหลด"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Click the button to connect to PayPal."
msgstr "คลิกปุ่มเพื่อเชื่อมต่อกับ PayPal"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone"
msgstr "โคลน"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone resource"
msgstr "โคลนทรัพยากร"

#. Button action
#: src/components/modal/WModal.tsx
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/access/delegation/AddImpersonationForm.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
msgid "Close"
msgstr "ปิด"

#. Label for an authentication error code
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Code:"
msgstr "รหัส:"

#. Server has been pre-paid
#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Committed"
msgstr "ชำระล่วงหน้าแล้ว"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Company name"
msgstr "ชื่อบริษัท"

#: src/styles/dataxion/theme.tsx
msgid "Company RNE number"
msgstr "หมายเลข RNE ของบริษัท"

#: src/modules/access/token/TokenView.tsx
msgid "Comprehensive API manual with code samples is available here:"
msgstr "คู่มือ API ฉบับสมบูรณ์พร้อมตัวอย่างโค้ดมีให้ที่นี่:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Compute"
msgstr "คอมพิวต์"

#. Alternative: Configure a custom subnet range
#: src/modules/network/NetworkCreate.tsx
msgid "Configure my own"
msgstr "กำหนดเอง"

#: src/modules/login/Login.tsx
msgid "Confirm email"
msgstr "ยืนยันอีเมล"

#: src/modules/compute/PasswordFields.tsx
msgid "Confirm password"
msgstr "ยืนยันรหัสผ่าน"

#: src/modules/login/Login.tsx
msgid "Confirm your email address by clicking the verification link we just sent to your inbox."
msgstr "ยืนยันที่อยู่อีเมลของคุณโดยคลิกลิงก์ยืนยันที่เราเพิ่งส่งไปยังกล่องจดหมายของคุณ"

#: src/components/modal/DeleteModal.tsx
#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Confirmation"
msgstr "ยืนยัน"

#: src/modules/compute/WVnc.tsx
msgid "Connect"
msgstr "เชื่อมต่อ"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Connect to PayPal first"
msgstr "เชื่อมต่อกับ PayPal ก่อน"

#: src/modules/compute/WVnc.tsx
msgid "Connecting"
msgstr "กำลังเชื่อมต่อ"

#: src/modules/billing/progressLabels.tsx
msgid "Connecting payment method"
msgstr "กำลังเชื่อมต่อวิธีการชำระเงิน"

#. Title for section that contains credentials to connect to a database
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/ServiceView.tsx
msgid "Connection details"
msgstr "รายละเอียดการเชื่อมต่อ"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's name"
msgstr "ชื่อผู้ติดต่อ"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's phone"
msgstr "โทรศัพท์ผู้ติดต่อ"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/support/ContactSupportButton.tsx
msgid "Contact support"
msgstr "ติดต่อฝ่ายสนับสนุน"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
#: src/modules/login/ConsentForm.tsx
#: src/modules/login/Login.tsx
msgid "Continue"
msgstr "ดำเนินการต่อ"

#: src/components/ClipBoardTooltip.tsx
msgid "Copied!"
msgstr "คัดลอกแล้ว!"

#. Full form: Copy to clipboard
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Copy"
msgstr "คัดลอก"

#: src/modules/services/Access.tsx
msgid "Copy config to clipboard"
msgstr "คัดลอกคอนฟิกไปยังคลิปบอร์ด"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Copy public URL"
msgstr "คัดลอก URL สาธารณะ"

#: src/components/ClipBoardTooltip.tsx
msgid "Copy to clipboard"
msgstr "คัดลอกไปยังคลิปบอร์ด"

#. All the main resources and services offered by the cloud platform
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Core services"
msgstr "บริการหลัก"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Country"
msgstr "ประเทศ"

#. Part of address
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "County"
msgstr "เขต/อำเภอ"

#: src/modules/compute/MetricsGrid.tsx
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/compute/VmSizeSelect.tsx
msgid "CPU"
msgstr "CPU"

#. Button: Create a new resource
#: src/components/forms/CreateFormAction.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Create"
msgstr "สร้าง"

#. Button: Create new billing account
#: src/modules/dashboard/BillingAccounts.tsx
msgctxt "Should be short (1-3 words)"
msgid "Create"
msgstr "สร้าง"

#: src/modules/billing/BillingList.tsx
msgid "Create a billing account first, then you can start creating resources."
msgstr "สร้างบัญชีการเรียกเก็บเงินก่อน แล้วคุณจึงจะเริ่มสร้างทรัพยากรได้"

#: src/modules/api/resourceTypes.tsx
msgid "Create a dedicated bare metal server and run your application with maximum performance."
msgstr "สร้างเซิร์ฟเวอร์ Bare Metal แบบเฉพาะและรันแอปพลิเคชันของคุณด้วยประสิทธิภาพสูงสุด"

#: src/modules/error/ErrorFallback.tsx
msgid "Create a new {resourceTypeName}"
msgstr "สร้าง{resourceTypeName}ใหม่"

#: src/modules/access/AccessList.tsx
msgid "Create a new access to enable other users or systems to perform actions with this {siteName} account."
msgstr "สร้างการเข้าถึงใหม่เพื่อให้ผู้ใช้อื่นหรือระบบอื่นสามารถดำเนินการกับบัญชี {siteName} นี้ได้"

#: src/modules/disks/DiskList.tsx
msgid "Create a new disk and start storing your data."
msgstr "สร้างดิสก์ใหม่และเริ่มจัดเก็บข้อมูลของคุณ"

#: src/modules/compute/VmList.tsx
#: src/modules/metal/MetalList.tsx
msgid "Create a new resource and get your services running in minutes."
msgstr "สร้างทรัพยากรใหม่และเริ่มใช้งานบริการของคุณได้ภายในไม่กี่นาที"

#: src/modules/network/NetworkList.tsx
msgid "Create a new resource and start managing your network."
msgstr "สร้างทรัพยากรใหม่และเริ่มจัดการเครือข่ายของคุณ"

#: src/modules/services/ServicesList.tsx
msgid "Create a new service and get it running in minutes."
msgstr "สร้างบริการใหม่และเริ่มใช้งานได้ภายในไม่กี่นาที"

#: src/modules/api/resourceTypes.tsx
msgid "Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "สร้างบัญชีจัดเก็บข้อมูลใหม่ สร้างบัคเก็ตบางส่วน และเริ่มจัดเก็บข้อมูลของคุณได้อย่างยืดหยุ่น พร้อมจ่ายตามการใช้งานที่เพิ่มขึ้น"

#: src/modules/storage/StorageList.tsx
msgid "Create a new storage account, create some buckets and start storing your data."
msgstr "สร้างบัญชีจัดเก็บข้อมูลใหม่ สร้างบัคเก็ต และเริ่มจัดเก็บข้อมูลของคุณ"

#: src/modules/api/resourceTypes.tsx
msgid "Create a new Virtual Machine or choose something from the App Catalog to get your services running in minutes."
msgstr "สร้างเครื่องเสมือนใหม่ หรือเลือกสิ่งที่ต้องการจากแค็ตตาล็อกแอปเพื่อให้บริการของคุณพร้อมใช้งานได้ภายในไม่กี่นาที"

#: src/modules/api/resourceTypes.tsx
msgid "Create a personal Virtual Private Cloud (VPC) and start managing your networks."
msgstr "สร้าง Virtual Private Cloud (VPC) ส่วนตัวและเริ่มจัดการเครือข่ายของคุณ"

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "Create a public IPv4 address for the resource"
msgstr "สร้างที่อยู่ IPv4 สาธารณะสำหรับทรัพยากร"

#: src/modules/disks/DiskCreate.tsx
msgid "Create additional storage for your workloads. Configure the disk and attach it to a virtual machine now or later."
msgstr "สร้างพื้นที่จัดเก็บเพิ่มเติมสำหรับเวิร์กโหลดของคุณ กำหนดค่าดิสก์และเชื่อมต่อกับเครื่องเสมือนได้ทันทีหรือภายหลัง"

#: src/modules/login/Login.tsx
msgid "Create an account"
msgstr "สร้างบัญชี"

#: src/modules/api/resourceTypes.tsx
msgid "Create an API Token to use our API."
msgstr "สร้างโทเค็น API เพื่อใช้งาน API ของเรา"

#. placeholder {0}: getResourceTypeName(type)
#: src/components/loading/Loading.tsx
msgid "Create another {0}"
msgstr "สร้าง {0} อีกหนึ่งรายการ"

#: src/components/forms/CreateBillingAccount.tsx
msgid "Create billing account"
msgstr "สร้างบัญชีการเรียกเก็บเงิน"

#: src/components/forms/CreateBillingAccount.tsx
#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/CoreServices.tsx
#: src/modules/dashboard/ManagedServices.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/StorageCreate.tsx
#: src/modules/storage/StorageList.tsx
msgid "Create new"
msgstr "สร้างใหม่"

#. Created at timestamp
#: src/modules/access/AccessList.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created"
msgstr "สร้างเมื่อ"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created at"
msgstr "สร้างเมื่อ"

#: src/modules/access/AccessList.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServicesList.tsx
msgid "Created date"
msgstr "วันที่สร้าง"

#: src/modules/compute/ModalHeaderBlock.tsx
msgid "Created from"
msgstr "สร้างจาก"

#. Virtual machine status
#: src/components/loading/Loading.tsx
#: src/modules/compute/statusLabels.tsx
msgid "Creating"
msgstr "กำลังสร้าง"

#: src/modules/access/AccessCreate.tsx
msgid "Creating an access by API Token gives you a key to use with our API."
msgstr "การสร้างการเข้าถึงด้วยโทเค็น API จะทำให้คุณได้รับคีย์สำหรับใช้งานกับ API ของเรา"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Credit"
msgstr "เครดิต"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Credit Note {id}"
msgstr "ใบลดหนี้ {id}"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Current"
msgstr "ปัจจุบัน"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Current billing cycle"
msgstr "รอบการเรียกเก็บเงินปัจจุบัน"

#. Explanation: Restoring a snapshot or backup will delete the current state of the virtual machine.
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Current changes will be discarded."
msgstr "การเปลี่ยนแปลงปัจจุบันจะถูกละทิ้ง"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Current usage"
msgstr "การใช้งานปัจจุบัน"

#: src/modules/compute/VmSizeSelect.tsx
msgid "Currently not available"
msgstr "ขณะนี้ยังไม่พร้อมใช้งาน"

#. Custom operating system
#: src/modules/compute/os/OsInfo.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Custom"
msgstr "กำหนดเอง"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Custom ISO image"
msgstr "อิมเมจ ISO แบบกำหนดเอง"

#: src/modules/support/WChatProvider.tsx
msgid "Customer support"
msgstr "ฝ่ายบริการลูกค้า"

#: src/modules/billing/payment_forms/labels.tsx
msgid "CVC"
msgstr "CVC"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Dark"
msgstr "มืด"

#: src/modules/dashboard/Dashboard.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Dashboard"
msgstr "แดชบอร์ด"

#: src/modules/location/LocationDetail.tsx
msgid "Data center where resource is located"
msgstr "ศูนย์ข้อมูลที่ทรัพยากรตั้งอยู่"

#: src/modules/location/LocationField.tsx
msgid "Data center where the resource will be created."
msgstr "ศูนย์ข้อมูลที่จะสร้างทรัพยากร"

#: src/components/forms/WSelect.tsx
msgid "Data missing"
msgstr "ข้อมูลไม่ครบถ้วน"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Date"
msgstr "วันที่"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Declined / Suspended"
msgstr "ถูกปฏิเสธ / ถูกระงับ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/dashboard/BillingAccounts.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Default"
msgstr "ค่าเริ่มต้น"

#: src/modules/access/AccessCreate.tsx
msgid "Delegate access to"
msgstr "มอบสิทธิ์การเข้าถึงให้"

#: src/modules/api/resourceTypes.tsx
msgid "Delegate access to your user or billing account so trusted users can manage your resources."
msgstr "มอบสิทธิ์การเข้าถึงให้กับบัญชีผู้ใช้หรือบัญชีการเรียกเก็บเงินของคุณ เพื่อให้ผู้ใช้ที่เชื่อถือได้สามารถจัดการทรัพยากรของคุณได้"

#: src/modules/user/ProfileView.tsx
msgid "Delegate new access"
msgstr "มอบสิทธิ์การเข้าถึงใหม่"

#: src/modules/access/AccessCreate.tsx
msgid "Delegating access to a chosen trusted user enables the user to act as you and perform all operations on behalf of your user or billing account."
msgstr "การมอบสิทธิ์การเข้าถึงให้ผู้ใช้ที่เชื่อถือได้ที่คุณเลือก จะทำให้ผู้ใช้นั้นสามารถดำเนินการในนามของคุณ และดำเนินการทั้งหมดแทนบัญชีผู้ใช้หรือบัญชีการเรียกเก็บเงินของคุณได้"

#: src/components/button/DeleteButton.tsx
#: src/components/modal/DeleteModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Delete"
msgstr "ลบ"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Delete floating IP"
msgstr "ลบไอพีลอยตัว"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
#: src/modules/metal/status/StatusLabels.tsx
msgid "Deleted"
msgstr "ลบแล้ว"

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "การลบ \"{display_name}\" จะเป็นการลบถาวร และจะไม่สามารถเข้าถึงได้อีกหลังจากนั้น"

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" would destroy a resource that has already been paid for. Please contact support for assistance."
msgstr "การลบ \"{display_name}\" จะทำลายทรัพยากรที่ชำระเงินแล้ว โปรดติดต่อฝ่ายสนับสนุนเพื่อขอความช่วยเหลือ"

#: src/modules/access/delegation/DelegationView.tsx
msgid "Deleting \"{name}\" will permanently remove access from all the users in this group to act as you."
msgstr "การลบ \"{name}\" จะเป็นการเพิกถอนสิทธิ์การเข้าถึงอย่างถาวรจากผู้ใช้ทั้งหมดในกลุ่มนี้ในการดำเนินการในนามของคุณ"

#. Items: means files or folders
#. placeholder {0}: files.length
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Deleting {count} {0, plural, one {item} other {items}}."
msgstr "กำลังลบ {count} {0, plural, one {รายการ} other {รายการ}}"

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a backup will permanently remove it."
msgstr "การลบข้อมูลสำรองจะเป็นการลบถาวร"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a billing account \"{title}\" will remove it permanently. Billing account can be deleted only if there are no unpaid resources attached to it and if it has no unspent credit."
msgstr "การลบบัญชีการเรียกเก็บเงิน \"{title}\" จะเป็นการลบอย่างถาวร สามารถลบบัญชีการเรียกเก็บเงินได้เฉพาะเมื่อไม่มีทรัพยากรที่ค้างชำระผูกอยู่ และไม่มียอดเครดิตคงเหลือที่ยังไม่ได้ใช้"

#. placeholder {0}: method.name
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a payment method \"{0}\" will remove it from the billing account."
msgstr "การลบวิธีชำระเงิน \"{0}\" จะเป็นการนำออกจากบัญชีการเรียกเก็บเงิน"

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting a service will also delete your backups and the service cannot be restored after that."
msgstr "การลบบริการจะลบข้อมูลสำรองของคุณด้วย และจะไม่สามารถกู้คืนบริการได้อีกหลังจากนั้น"

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a snapshot will permanently remove it."
msgstr "การลบสแนปช็อตจะเป็นการลบถาวร"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the access key \"{accessKey}\" will permanently remove it, and it cannot be used for accessing the storage API after that."
msgstr "การลบคีย์การเข้าถึง \"{accessKey}\" จะเป็นการลบอย่างถาวร และจะไม่สามารถใช้เข้าถึง API ของที่เก็บข้อมูลได้อีกหลังจากนั้น"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the credit card \"{placeholder}\" will permanently remove it from the billing account."
msgstr "การลบบัตรเครดิต \"{placeholder}\" จะเป็นการนำออกจากบัญชีการเรียกเก็บเงินอย่างถาวร"

#: src/modules/compute/DiskDeleteModal.tsx
msgid "Deleting the disk will permanently remove it, and it will not be accessible after that."
msgstr "การลบดิสก์จะเป็นการนำออกอย่างถาวร และจะไม่สามารถเข้าถึงได้อีกหลังจากนั้น"

#. placeholder {0}: name || address
#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Deleting the floating IP address \"{0}\" will remove it from your account and release it to the public pool."
msgstr "การลบไอพีลอยตัว \"{0}\" จะนำออกจากบัญชีของคุณและคืนกลับไปยังพูลสาธารณะ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the invoice method will permanently remove it from the billing account."
msgstr "การลบวิธีชำระเงินแบบใบแจ้งหนี้จะเป็นการนำออกจากบัญชีการเรียกเก็บเงินอย่างถาวร"

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting the service \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "การลบบริการ \"{display_name}\" จะเป็นการลบอย่างถาวร และจะไม่สามารถเข้าถึงได้อีกหลังจากนั้น"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the storage account \"{title}\" will permanently remove it and delete all associated keys. Accounts with active buckets cannot be deleted."
msgstr "การลบบัญชีจัดเก็บข้อมูล \"{title}\" จะเป็นการลบอย่างถาวรและลบคีย์ที่เกี่ยวข้องทั้งหมด บัญชีที่มีบัคเก็ตที่ยังใช้งานอยู่จะไม่สามารถลบได้"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Deleting the storage bucket \"{name}\" will permanently remove it, and any files in it will not be accessible after that."
msgstr "การลบบัคเก็ตจัดเก็บข้อมูล \"{name}\" จะเป็นการลบอย่างถาวร และไฟล์ทั้งหมดภายในจะไม่สามารถเข้าถึงได้อีกหลังจากนั้น"

#: src/modules/access/token/TokenView.tsx
msgid "Deleting the token \"{description}\" will permanently remove it, and it cannot be used for authentication after that."
msgstr "การลบโทเค็น \"{description}\" จะเป็นการลบอย่างถาวร และจะไม่สามารถใช้สำหรับการยืนยันตัวตนได้อีกหลังจากนั้น"

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine \"{name}\" will permanently remove it, and it will not be accessible after that."
msgstr "การลบเครื่องเสมือน \"{name}\" จะเป็นการลบถาวร และจะไม่สามารถเข้าถึงได้อีกหลังจากนั้น"

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine will also delete your backups and snapshots, and the machine cannot be restored after that. If you wish to keep the backups and snapshots consider stopping the machine instead."
msgstr "การลบเครื่องเสมือนจะลบข้อมูลสำรองและสแนปช็อตของคุณด้วย และจะไม่สามารถกู้คืนเครื่องได้อีกหลังจากนั้น หากคุณต้องการเก็บข้อมูลสำรองและสแนปช็อตไว้ โปรดพิจารณาหยุดเครื่องแทน"

#: src/modules/network/vpc/VpcView.tsx
msgid "Deleting the VPC network \"{name}\" will remove it from your account."
msgstr "การลบเครือข่าย VPC \"{name}\" จะนำออกจากบัญชีของคุณ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Description"
msgstr "คำอธิบาย"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Destinations"
msgstr "ปลายทาง"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/UnattachedItem.tsx
msgid "Detached"
msgstr "ถอดออกแล้ว"

#: src/modules/compute/VmView.tsx
msgid "Disable"
msgstr "ปิดใช้งาน"

#: src/modules/compute/VmView.tsx
msgid "Disable backups"
msgstr "ปิดการสำรองข้อมูล"

#: src/modules/user/ProfileView.tsx
msgid "Disable MFA"
msgstr "ปิดใช้งาน MFA"

#: src/components/EnabledDisabled.tsx
msgid "Disabled"
msgstr "ปิดใช้งาน"

#: src/modules/compute/WVnc.tsx
msgid "Disconnect"
msgstr "ตัดการเชื่อมต่อ"

#. State of connection: Not connected
#: src/modules/compute/WVnc.tsx
msgid "Disconnected"
msgstr "ไม่ได้เชื่อมต่อ"

#. Column title for invoice records' discount
#: src/components/PriceWithDiscount.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Discount"
msgstr "ส่วนลด"

#: src/modules/api/resourceTypes.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Disk"
msgstr "ดิสก์"

#: src/modules/compute/MetricsGrid.tsx
msgid "Disk I/O"
msgstr "I/O ของดิสก์"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
msgid "Disk size can only be increased. This action is not reversible. Minimum disk size:"
msgstr "ขนาดดิสก์เพิ่มได้เท่านั้น การดำเนินการนี้ไม่สามารถย้อนกลับได้ ขนาดดิสก์ขั้นต่ำ:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Disks"
msgstr "ดิสก์"

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/CurrencyModal.tsx
msgid "Display currency"
msgstr "สกุลเงินที่ใช้แสดงราคา"

#: src/modules/storage/StorageCreate.tsx
msgid "Display name"
msgstr "ชื่อที่แสดง"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Document"
msgstr "เอกสาร"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Document file"
msgstr "ไฟล์เอกสาร"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Document No."
msgstr "เลขที่เอกสาร"

#. Button action to download a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Download"
msgstr "ดาวน์โหลด"

#: src/modules/services/Access.tsx
msgid "Download config file"
msgstr "ดาวน์โหลดไฟล์คอนฟิก"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Download PDF"
msgstr "ดาวน์โหลด PDF"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Drop files here"
msgstr "ลากไฟล์มาวางที่นี่"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Due date"
msgstr "วันครบกำหนด"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "E-mail"
msgstr "อีเมล"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit"
msgstr "แก้ไข"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Edit \"{title}\""
msgstr "แก้ไข \"{title}\""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Edit maintenance"
msgstr "แก้ไขการบำรุงรักษา"

#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit name"
msgstr "แก้ไขชื่อ"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Edit node"
msgstr "แก้ไขโหนด"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "Edit rule"
msgstr "แก้ไขกฎ"

#. Field label
#: src/components/EditableList.tsx
#: src/modules/login/Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Email"
msgstr "อีเมล"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Email domain is prohibited"
msgstr "ไม่อนุญาตให้ใช้โดเมนอีเมลนี้"

#: src/modules/login/Login.tsx
msgid "Email verification failed"
msgstr "การยืนยันอีเมลล้มเหลว"

#: src/modules/login/Login.tsx
msgid "Email verified"
msgstr "ยืนยันอีเมลแล้ว"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Email where invoices and reports are sent."
msgstr "อีเมลที่จะใช้รับใบแจ้งหนี้และรายงาน"

#: src/modules/compute/VmCreate.tsx
msgid "Empty disk (for ISO booting)"
msgstr "ดิสก์เปล่า (สำหรับบูตจาก ISO)"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Enable"
msgstr "เปิดใช้งาน"

#: src/modules/user/ProfileView.tsx
msgid "Enable MFA"
msgstr "เปิดใช้งาน MFA"

#: src/modules/access/AccessCreate.tsx
msgid "Enable other users or systems to perform actions with resources connected to this account."
msgstr "อนุญาตให้ผู้ใช้อื่นหรือระบบอื่นดำเนินการกับทรัพยากรที่เชื่อมโยงกับบัญชีนี้"

#: src/components/EnabledDisabled.tsx
msgid "Enabled"
msgstr "เปิดใช้งาน"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "End date"
msgstr "วันที่สิ้นสุด"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "End port"
msgstr "พอร์ตสิ้นสุด"

#: src/modules/network/firewall/validatePorts.ts
msgid "End port must be greater than start port"
msgstr "พอร์ตสิ้นสุดต้องมีค่ามากกว่าพอร์ตเริ่มต้น"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Ended"
msgstr "สิ้นสุดแล้ว"

#: src/modules/compute/AddSubInterfaceModal.tsx
msgid "Enter a value between 1 and 4094"
msgstr "ป้อนค่าระหว่าง 1 ถึง 4094"

#. Card security code validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Enter digits only"
msgstr "กรอกเฉพาะตัวเลข"

#. placeholder {0}: currency.title
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Enter the top up amount in {0} (minimum {minimumAmount}):"
msgstr "กรอกจำนวนเงินที่จะเติมในสกุล {0} (ขั้นต่ำ {minimumAmount}):"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/error/Isolated.tsx
#: src/modules/login/Login.tsx
#: src/modules/notifications/toast.tsx
msgid "Error"
msgstr "ข้อผิดพลาด"

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Error adding payment method"
msgstr "เกิดข้อผิดพลาดในการเพิ่มวิธีการชำระเงิน"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Error code: {code}"
msgstr "รหัสข้อผิดพลาด: {code}"

#: src/components/button/WButton.tsx
msgid "Error performing action"
msgstr "เกิดข้อผิดพลาดในการดำเนินการ"

#: src/modules/notifications/toast.tsx
msgid "Error saving changes"
msgstr "เกิดข้อผิดพลาดขณะบันทึกการเปลี่ยนแปลง"

#: src/modules/compute/VmView.tsx
msgid "Est. cost per backup"
msgstr "ค่าใช้จ่ายโดยประมาณต่อการสำรองข้อมูล"

#: src/components/table/DetailsTableMonthlyCost.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Est. monthly cost"
msgstr "ค่าใช้จ่ายต่อเดือนโดยประมาณ"

#. Short of: Estimated
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Est. total"
msgstr "ยอดรวมโดยประมาณ"

#: src/components/forms/MonthlyCostField.tsx
msgid "Estimated cost"
msgstr "ค่าใช้จ่ายโดยประมาณ"

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per backup is {priceWithDiscount} per month."
msgstr "ราคาโดยประมาณต่อข้อมูลสำรองคือ {priceWithDiscount} ต่อเดือน"

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per snapshot is {priceWithDiscount} per month."
msgstr "ราคาโดยประมาณต่อสแนปช็อตคือ {priceWithDiscount} ต่อเดือน"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user receives a {c_totalReceiverCredit} worth of free credits when signing up through the referral link or code and adding a verified payment method."
msgstr "ผู้ใช้ใหม่ทุกคนจะได้รับเครดิตฟรีมูลค่า {c_totalReceiverCredit} เมื่อสมัครผ่านลิงก์หรือรหัสแนะนำ และเพิ่มวิธีการชำระเงินที่ผ่านการยืนยันแล้ว"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user who signs up through the referral program and tops up at least {c_minimumTopUp} will receive a bonus worth of {c_totalReceiverCredit} credits."
msgstr "ผู้ใช้ใหม่ทุกคนที่สมัครผ่านโปรแกรมแนะนำเพื่อนและเติมเงินอย่างน้อย {c_minimumTopUp} จะได้รับโบนัสมูลค่า {c_totalReceiverCredit} เครดิต"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Example"
msgstr "ตัวอย่าง"

#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/DisplayCurrencyRate.tsx
msgid "Exchange rate"
msgstr "อัตราแลกเปลี่ยน"

#. Short of: Excluding (VAT/GST etc.)
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Excl. {vatSymbol}"
msgstr "ไม่รวม {vatSymbol}"

#. The number of fail-over nodes:
#: src/modules/services/ServiceCreate.tsx
msgid "Fail-over nodes"
msgstr "โหนด Fail-over"

#: src/modules/api/ApiError.ts
msgid "Failed to connect to server"
msgstr "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้"

#: src/modules/billing/account_validation/digio/utils.ts
msgid "Failed to load Digio library"
msgstr "ไม่สามารถโหลดไลบรารี Digio ได้"

#: src/modules/billing/paypal/utils.ts
msgid "Failed to load PayPal library"
msgstr "ไม่สามารถโหลดไลบรารี PayPal ได้"

#: src/modules/billing/popup/popup.ts
msgid "Failed to open popup, possible popup blocker usage"
msgstr "ไม่สามารถเปิดป๊อปอัปได้ อาจเกิดจากการใช้ตัวบล็อกป๊อปอัป"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "File"
msgstr "ไฟล์"

#: src/modules/storage/bucket/BucketView.tsx
msgid "Files"
msgstr "ไฟล์"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Files will be uploaded to"
msgstr "ไฟล์จะถูกอัปโหลดไปยัง"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Firewall"
msgstr "ไฟร์วอลล์"

#: src/modules/network/NetworkCreate.tsx
msgid "Firewall is available at no additional cost."
msgstr "ไฟร์วอลล์พร้อมให้ใช้งานโดยไม่มีค่าใช้จ่ายเพิ่มเติม"

#: src/modules/compute/VmView.tsx
msgid "Firewall name"
msgstr "ชื่อไฟร์วอลล์"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Firewall now available"
msgstr "ไฟร์วอลล์พร้อมใช้งานแล้ว"

#: src/modules/user/ProfileView.tsx
msgid "First name"
msgstr "ชื่อ"

#: src/modules/services/ConnectionDetails.tsx
msgid "Flags"
msgstr "แฟล็ก"

#: src/modules/api/resourceTypes.tsx
msgid "Floating IP"
msgstr "ไอพีลอยตัว"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder"
msgstr "โฟลเดอร์"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder name"
msgstr "ชื่อโฟลเดอร์"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up through the referral program and tops up at least {c_minimumTopUp}, you will receive {c_promoterCredit} worth of free credits."
msgstr "สำหรับผู้ใช้ใหม่ทุกคนที่สมัครผ่านโปรแกรมแนะนำเพื่อนและเติมเงินอย่างน้อย {c_minimumTopUp} คุณจะได้รับเครดิตฟรีมูลค่า {c_promoterCredit}"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up using your referral code and adds a verified payment method, you will receive {c_promoterCredit} worth of free credits."
msgstr "สำหรับผู้ใช้ใหม่ทุกคนที่สมัครใช้งานด้วยรหัสแนะนำของคุณและเพิ่มวิธีการชำระเงินที่ผ่านการยืนยันแล้ว คุณจะได้รับเครดิตฟรีมูลค่า {c_promoterCredit}"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "For pay-as-you-go billing account you can select the payment method after the account is created and validated."
msgstr "สำหรับบัญชีการเรียกเก็บเงินแบบจ่ายตามการใช้งาน คุณสามารถเลือกวิธีชำระเงินได้หลังจากสร้างบัญชีและผ่านการตรวจสอบยืนยันแล้ว"

#: src/modules/compute/labels.tsx
msgid "For the snapshots you will only pay for the storage used by the snapshot."
msgstr "สำหรับสแนปช็อต คุณจะชำระเงินเฉพาะพื้นที่จัดเก็บที่สแนปช็อตใช้งานเท่านั้น"

#. Unsafely shut down the virtual machine
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Force stop"
msgstr "บังคับหยุด"

#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
msgid "Forgot password"
msgstr "ลืมรหัสผ่าน"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Forwarding rules"
msgstr "กฎการส่งต่อ"

#. At no cost. | POS: Noun
#: src/components/forms/MonthlyCostField.tsx
msgid "Free"
msgstr "ฟรี"

#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
msgid "Frequency"
msgstr "ความถี่"

#: src/modules/services/ServicesList.tsx
msgid "from"
msgstr "เริ่มต้นที่"

#: src/modules/compute/VmCreate.tsx
msgid "From"
msgstr "จาก"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Full path"
msgstr "พาธแบบเต็ม"

#: src/modules/services/ServiceView.tsx
msgid "Fully managed database so you can focus on your code."
msgstr "ฐานข้อมูลที่มีการจัดการเต็มรูปแบบ เพื่อให้คุณโฟกัสกับโค้ดของคุณได้"

#: src/modules/api/resourceTypes.tsx
msgid "Fully managed services - we handle the provisioning of underlying infrastructure and the management of the service."
msgstr "บริการแบบจัดการให้ครบวงจร - เราดูแลทั้งการจัดเตรียมโครงสร้างพื้นฐานเบื้องหลังและการบริหารจัดการบริการ"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Future"
msgstr "ในอนาคต"

#. Payment gateway that the card is connected to
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Gateway"
msgstr "ผู้ให้บริการชำระเงิน"

#. unit: gigabytes
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/l10n/units.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "GB"
msgstr "GB"

#. Example: 50 GB (of) disk
#: src/modules/l10n/units.tsx
msgid "GB disk"
msgstr "ดิสก์ GB"

#. Example: 16 GB (of) RAM
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/l10n/units.tsx
msgid "GB RAM"
msgstr "GB RAM"

#. unit: gigabyte-hours (storage usage)
#: src/modules/l10n/units.tsx
msgid "GBh"
msgstr "GBh"

#. Explanation: Generate the subnet range automatically
#: src/modules/network/NetworkCreate.tsx
msgid "Generate (recommended)"
msgstr "สร้างอัตโนมัติ (แนะนำ)"

#: src/modules/access/AccessCreate.tsx
msgid "Generate an API access token to use our <0>API</0>."
msgstr "สร้างโทเค็นการเข้าถึง API เพื่อใช้กับ <0>API</0> ของเรา"

#: src/modules/access/scopeLabel.tsx
msgid "Global"
msgstr "ทั่วทั้งบัญชี"

#: src/modules/error/ErrorFallback.tsx
msgid "Go to dashboard"
msgstr "ไปที่แดชบอร์ด"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST"
msgstr "GST"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST number"
msgstr "หมายเลข GST"

#. unit: hours
#: src/modules/l10n/units.tsx
msgid "h"
msgstr "ชม."

#. Chat widget greeting
#: src/modules/support/WChatProvider.tsx
msgid "Hello"
msgstr "สวัสดี"

#: src/routes/_main_custom/about.lazy.tsx
msgid "Hello world!"
msgstr "สวัสดีโลก!"

#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Hibernate"
msgstr "ไฮเบอร์เนต"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernated"
msgstr "ไฮเบอร์เนตแล้ว"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernating"
msgstr "กำลังไฮเบอร์เนต"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Hide"
msgstr "ซ่อน"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Hide details"
msgstr "ซ่อนรายละเอียด"

#: src/modules/api/resourceTypes.tsx
msgid "High availability load balancer distributes traffic between virtual machines within the same data center location."
msgstr "โหลดบาลานเซอร์แบบความพร้อมใช้งานสูงจะกระจายทราฟฟิกระหว่างเครื่องเสมือนภายในศูนย์ข้อมูลแห่งเดียวกัน"

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/period.tsx
msgid "hour"
msgstr "ชั่วโมง"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Hourly"
msgstr "รายชั่วโมง"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Hourly billing cycle only"
msgstr "รองรับเฉพาะรอบการเรียกเก็บเงินรายชั่วโมง"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Hourly updated usage for current billing period."
msgstr "การใช้งานที่อัปเดตรายชั่วโมงสำหรับรอบการเรียกเก็บเงินปัจจุบัน"

#: src/modules/dashboard/UserAccess.tsx
msgid "I can access"
msgstr "ฉันเข้าถึงได้"

#: src/modules/login/ConsentForm.tsx
msgid "I have read and agree to the <0>Terms of Service</0>"
msgstr "ฉันได้อ่านและยอมรับ<0>ข้อกำหนดในการให้บริการ</0>"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "I'm aware that deletion is permanent"
msgstr "ฉันทราบว่าการลบเป็นการลบถาวร"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "If low balance notifications are active and the balance falls below the threshold, you will be notified."
msgstr "หากเปิดใช้การแจ้งเตือนยอดคงเหลือต่ำ และยอดคงเหลือลดลงต่ำกว่าค่าที่กำหนด คุณจะได้รับการแจ้งเตือน"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "If the active reservation runs out and is not renewed then standard hourly based pricing will be applied."
msgstr "หากการจองที่ใช้งานอยู่สิ้นสุดลงและไม่ได้ต่ออายุ ระบบจะคิดค่าบริการตามอัตรามาตรฐานรายชั่วโมง"

#: src/modules/billing/choose_method/InvoiceForm.tsx
msgid "If the invoice payment method is not activated instantly, we will contact you with more details. If you do not receive an email from us soon or the invoice payment does not become active, you can contact us at <0/>."
msgstr "หากวิธีการชำระเงินแบบใบแจ้งหนี้ไม่ได้เปิดใช้งานทันที เราจะติดต่อคุณพร้อมรายละเอียดเพิ่มเติม หากคุณไม่ได้รับอีเมลจากเราในเร็ว ๆ นี้ หรือการชำระเงินแบบใบแจ้งหนี้ยังไม่ถูกเปิดใช้งาน คุณสามารถติดต่อเราได้ที่ <0/>"

#: src/modules/dashboard/Dashboard.tsx
msgid "If you have any questions, found a bug or have a feature request feel free to contact us through <0>support</0>."
msgstr "หากคุณมีคำถาม พบข้อบกพร่อง หรือต้องการขอฟีเจอร์เพิ่มเติม โปรดติดต่อเราผ่าน<0>ฝ่ายสนับสนุน</0>"

#. Description for billing period field
#: src/modules/metal/offer/period.tsx
msgid "In all calculations a precise number of hours is used: 730 for a month, 2190 for a quarter and 8760 for a year."
msgstr "การคำนวณทั้งหมดใช้จำนวนชั่วโมงที่แน่นอน: 730 ชั่วโมงต่อเดือน, 2,190 ชั่วโมงต่อไตรมาส และ 8,760 ชั่วโมงต่อปี"

#: src/modules/metal/status/StatusLabels.tsx
msgid "In use"
msgstr "กำลังใช้งาน"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Inactive"
msgstr "ไม่ใช้งาน"

#. Short of: inbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "inbound"
msgstr "ขาเข้า"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Inbound rules"
msgstr "กฎขาเข้า"

#. The price has already been included in the virtual machine's price
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Included in VM price"
msgstr "รวมอยู่ในราคา VM แล้ว"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Incoming traffic is allowed only to the specified ports if it originates from the specified sources. All other traffic will be blocked."
msgstr "ทราฟฟิกขาเข้าจะได้รับอนุญาตเฉพาะไปยังพอร์ตที่ระบุ หากมาจากแหล่งที่มาที่ระบุเท่านั้น ทราฟฟิกอื่นทั้งหมดจะถูกบล็อก"

#: src/modules/compute/VmCreate.tsx
msgid "Informative name. It will also be used to generate a suitable hostname for the VM (if applicable)."
msgstr "ชื่อสำหรับใช้อ้างอิง และจะถูกใช้เพื่อสร้างชื่อโฮสต์ที่เหมาะสมสำหรับ VM ด้วย (หากใช้ได้)"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/ServiceView.tsx
msgid "Infrastructure"
msgstr "โครงสร้างพื้นฐาน"

#: src/modules/compute/VmCreate.tsx
msgid "Initialization script"
msgstr "สคริปต์เริ่มต้นระบบ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Insert code"
msgstr "กรอกรหัส"

#: src/modules/access/AccessCreate.tsx
msgid "Insert email of the {siteName} user you want to delegate access to. The user will need to accept the access invitation from their profile view."
msgstr "กรอกอีเมลของผู้ใช้ {siteName} ที่คุณต้องการมอบสิทธิ์การเข้าถึงให้ ผู้ใช้จะต้องยอมรับคำเชิญการเข้าถึงจากหน้าโปรไฟล์ของตน"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Insufficient funds"
msgstr "ยอดเงินไม่เพียงพอ"

#. Field label: identifier used to connect a billing account to an external integration
#. Unique ID number to integrate with external services
#: src/modules/billing/billingAccount/fieldsInfo.tsx
#: src/styles/defaultTheme.tsx
msgid "Integration ID"
msgstr "รหัสการเชื่อมต่อ"

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid month"
msgstr "เดือนไม่ถูกต้อง"

#: src/modules/api/ApiError.ts
msgid "Invalid response from server. Blocked by Stormwall."
msgstr "การตอบกลับจากเซิร์ฟเวอร์ไม่ถูกต้อง ถูกบล็อกโดย Stormwall"

#: src/modules/api/ApiError.ts
msgid "Invalid response type from server: Received {ct} instead of JSON."
msgstr "ประเภทการตอบกลับจากเซิร์ฟเวอร์ไม่ถูกต้อง: ได้รับ {ct} แทน JSON"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Invalid signup. The account may already exist."
msgstr "การสมัครสมาชิกไม่ถูกต้อง บัญชีนี้อาจมีอยู่แล้ว"

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid year"
msgstr "ปีไม่ถูกต้อง"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Invoice"
msgstr "ใบแจ้งหนี้"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Invoice {id}"
msgstr "ใบแจ้งหนี้ {id}"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Invoice details"
msgstr "รายละเอียดใบแจ้งหนี้"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Invoice email"
msgstr "อีเมลสำหรับใบแจ้งหนี้"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice has been paid"
msgstr "ชำระใบแจ้งหนี้แล้ว"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice is not payable"
msgstr "ไม่สามารถชำระใบแจ้งหนี้ได้"

#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Invoice name"
msgstr "ชื่อใบแจ้งหนี้"

#: src/components/themeTrans.tsx
msgid "Invoices"
msgstr "ใบแจ้งหนี้"

#: src/modules/services/IpWhitelist.tsx
msgid "IP"
msgstr "IP"

#: src/modules/services/AddIpForm.tsx
msgid "IP address"
msgstr "ที่อยู่ IP"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "IP address or CIDR range"
msgstr "ที่อยู่ IP หรือช่วง CIDR"

#. A list of IPs permitted to access the service | Legacy wording: IP whitelist
#: src/modules/services/IpWhitelist.tsx
#: src/modules/services/ServiceView.tsx
msgid "IP allowlist"
msgstr "รายการ IP ที่อนุญาต"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "IP prefixes"
msgstr "พรีฟิกซ์ IP"

#: src/modules/network/NetworkCreate.tsx
msgid "IP range"
msgstr "ช่วง IP"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv4 range"
msgstr "ช่วง IPv4"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv6 range"
msgstr "ช่วง IPv6"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "ISO boot"
msgstr "บูตผ่าน ISO"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Issue date"
msgstr "วันที่ออกเอกสาร"

#. Date the invoice was issued
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Issued"
msgstr "วันที่ออก"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Keep floating IP"
msgstr "เก็บไอพีลอยตัวไว้"

#: src/modules/user/ActAsModal.tsx
msgid "Keep in mind that all the actions will be tracked and can be traced back to you."
msgstr "โปรดทราบว่าการดำเนินการทั้งหมดจะถูกติดตามและสามารถตรวจสอบย้อนกลับมาถึงคุณได้"

#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Key name"
msgstr "ชื่อคีย์"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Kubernetes Patch Version"
msgstr "เวอร์ชันแพตช์ของ Kubernetes"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Kubernetes Patch Version Auto update"
msgstr "การอัปเดตเวอร์ชันแพตช์ของ Kubernetes อัตโนมัติ"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Kubernetes service can not be created."
msgstr "ไม่สามารถสร้างบริการ Kubernetes ได้"

#: src/modules/l10n/LocaleButton.tsx
msgid "Language"
msgstr "ภาษา"

#: src/modules/network/vpc/VpcView.tsx
msgid "Last modified"
msgstr "แก้ไขล่าสุด"

#: src/modules/user/ProfileView.tsx
msgid "Last name"
msgstr "นามสกุล"

#: src/modules/compute/VmView.tsx
msgid "Latest backup"
msgstr "ข้อมูลสำรองล่าสุด"

#. Timestamp of latest snapshot
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/Backups.tsx
msgid "Latest snapshot"
msgstr "สแนปช็อตล่าสุด"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Less details"
msgstr "รายละเอียดน้อยลง"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Light"
msgstr "สว่าง"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Limit will be removed once the total top up amount reaches <0/>."
msgstr "ข้อจำกัดจะถูกยกเลิกเมื่อยอดเติมเงินรวมถึง <0/>"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Limited"
msgstr "จำกัด"

#. Column title for invoice records' totals - record amount subtracted by discount
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Line total"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Linked resources"
msgstr "ทรัพยากรที่เชื่อมโยง"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "list price"
msgstr "ราคาเต็ม"

#: src/modules/api/resourceTypes.tsx
msgid "Load balancer"
msgstr "โหลดบาลานเซอร์"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Load more"
msgstr "โหลดเพิ่มเติม"

#: src/modules/billing/progressLabels.tsx
msgid "Loading payment provider"
msgstr "กำลังโหลดผู้ให้บริการชำระเงิน"

#: src/components/forms/WSelect.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Loading..."
msgstr "กำลังโหลด..."

#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/location/LocationDetail.tsx
#: src/modules/location/LocationField.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/pricing/PricingModal.tsx
#: src/modules/services/ServicesList.tsx
msgid "Location"
msgstr "สถานที่ตั้ง"

#: src/modules/login/ApiKeyLogin.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/LoginLayout.tsx
msgid "Log in"
msgstr "เข้าสู่ระบบ"

#: src/modules/login/Login.tsx
msgid "Log in with Google"
msgstr "เข้าสู่ระบบด้วย Google"

#: src/modules/main/LogoutConfirmDialog.tsx
#: src/modules/user/LogoutButton.tsx
#: src/modules/user/UserMenu.tsx
msgid "Log out"
msgstr "ออกจากระบบ"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Logging in"
msgstr "กำลังเข้าสู่ระบบ"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Login error"
msgstr "ข้อผิดพลาดในการเข้าสู่ระบบ"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Look around first"
msgstr "ลองดูก่อน"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Low balance notification is not in effect because automated top up is activated."
msgstr "การแจ้งเตือนยอดคงเหลือต่ำไม่มีผล เนื่องจากได้เปิดใช้การเติมเงินอัตโนมัติอยู่"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Low balance notifications"
msgstr "การแจ้งเตือนยอดคงเหลือต่ำ"

#. MAC address
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "MAC"
msgstr "MAC"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Machine details"
msgstr "รายละเอียดเครื่อง"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is available for immediate leasing by clients."
msgstr "เครื่องพร้อมให้ลูกค้าเช่าใช้งานได้ทันที"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is being used by client and is being charged."
msgstr "เครื่องกำลังถูกใช้งานโดยลูกค้าและมีการเรียกเก็บเงินอยู่"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is ordered by client, but does not satisfy the required configuration.<0/>After it has been configured as needed, move to “in use” status."
msgstr "เครื่องถูกสั่งโดยลูกค้าแล้ว แต่ยังไม่ตรงตามการกำหนดค่าที่ต้องการ<0/>หลังจากกำหนดค่าตามที่ต้องการแล้ว ให้ย้ายไปเป็นสถานะ “กำลังใช้งาน”"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is unavailable or requires repairs."
msgstr "เครื่องไม่พร้อมใช้งานหรือต้องได้รับการซ่อมแซม"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine requires disk cleaning operations."
msgstr "เครื่องต้องดำเนินการล้างข้อมูลบนดิสก์"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Machine type"
msgstr "ประเภทเครื่อง"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/ServiceView.tsx
msgid "Maintenance"
msgstr "การบำรุงรักษา"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/UserMenu.tsx
msgid "Manage"
msgstr "จัดการ"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Manage API keys"
msgstr "จัดการคีย์ API"

#: src/modules/api/resourceTypes.tsx
msgid "Managed service"
msgstr "บริการแบบจัดการให้"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Managed services"
msgstr "บริการที่มีการจัดการ"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Max. surge"
msgstr "การเพิ่มขึ้นสูงสุด"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Maximize"
msgstr "ขยาย"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Maximum upload file size is {maxFileSizeInMB} MB"
msgstr "ขนาดไฟล์อัปโหลดสูงสุดคือ {maxFileSizeInMB} MB"

#. unit: megabytes
#: src/modules/l10n/units.tsx
msgid "MB"
msgstr "MB"

#. unit: megabytes per second
#: src/modules/l10n/units.tsx
msgid "MB/s"
msgstr "MB/s"

#. unit: megabits per second
#: src/modules/l10n/units.tsx
msgid "Mbit/s"
msgstr "Mbit/s"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Method"
msgstr "วิธีการ"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Methods available after validation"
msgstr "วิธีชำระเงินที่ใช้ได้หลังการตรวจสอบยืนยัน"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Metrics.tsx
#: src/modules/services/ServiceView.tsx
msgid "Metrics"
msgstr "เมตริก"

#: src/modules/compute/monitor/MetricChart.tsx
msgid "Metrics for this resource are not loaded for performance reasons"
msgstr "ไม่ได้โหลดเมตริกสำหรับทรัพยากรนี้ด้วยเหตุผลด้านประสิทธิภาพ"

#: src/modules/user/ProfileView.tsx
msgid "MFA is active for your user."
msgstr "เปิดใช้ MFA สำหรับผู้ใช้ของคุณแล้ว"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Minimize"
msgstr "ย่อ"

#. The selected item was not found
#: src/components/forms/WSelect.tsx
msgid "Missing"
msgstr "ไม่พบ"

#. If the disk is a boot disk
#: src/modules/compute/VmView.tsx
msgid "Mode"
msgstr "โหมด"

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
#: src/modules/metal/offer/period.tsx
msgid "month"
msgstr "เดือน"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Monthly"
msgstr "รายเดือน"

#: src/components/sidebar/PriceBlock.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/StorageList.tsx
msgid "Monthly cost"
msgstr "ค่าใช้จ่ายต่อเดือน"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "More details"
msgstr "รายละเอียดเพิ่มเติม"

#: src/modules/user/ProfileView.tsx
msgid "Multi-factor authentication (MFA)"
msgstr "การยืนยันตัวตนแบบหลายปัจจัย (MFA)"

#: src/modules/billing/forms/BillingSelect.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "N/A"
msgstr "ไม่มี"

#: src/components/table/DetailsTableName.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Name"
msgstr "ชื่อ"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name (Min {minChars} chars)"
msgstr "ชื่อ (อย่างน้อย {minChars} ตัวอักษร)"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name is too short"
msgstr "ชื่อสั้นเกินไป"

#: src/modules/support/WChatProvider.tsx
msgid "Need help?"
msgstr "ต้องการความช่วยเหลือหรือไม่?"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/network/NetworkList.tsx
msgid "Network"
msgstr "เครือข่าย"

#: src/modules/compute/MetricsGrid.tsx
msgid "Network bandwidth"
msgstr "แบนด์วิดท์เครือข่าย"

#: src/modules/compute/VmView.tsx
msgid "Network interfaces"
msgstr "อินเทอร์เฟซเครือข่าย"

#: src/modules/compute/VmView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Networking"
msgstr "ระบบเครือข่าย"

#: src/components/sidebar/SidebarList.tsx
#: src/modules/network/NetworkList.tsx
msgid "New"
msgstr "ใหม่"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New file name"
msgstr "ชื่อไฟล์ใหม่"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder"
msgstr "โฟลเดอร์ใหม่"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder name"
msgstr "ชื่อโฟลเดอร์ใหม่"

#: src/modules/network/VpcNetworkSelect.tsx
msgid "New network"
msgstr "เครือข่ายใหม่"

#: src/modules/compute/PasswordFields.tsx
msgid "New password"
msgstr "รหัสผ่านใหม่"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "New SSH key"
msgstr "คีย์ SSH ใหม่"

#: src/styles/nforce/theme.tsx
msgid "NForce customer ID"
msgstr "รหัสลูกค้า NForce"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "No active card"
msgstr "ไม่มีบัตรที่ใช้งานอยู่"

#. Chart empty state: no metric samples are available
#: src/modules/compute/monitor/MetricChart.tsx
msgid "No data"
msgstr "ไม่มีข้อมูล"

#. Fail-over is disabled, no fail-over nodes
#: src/modules/services/FailoverNodeSelect.tsx
msgid "No Fail-over"
msgstr "ไม่มี Fail-over"

#: src/modules/dashboard/UserAccess.tsx
msgid "No one can access your user account yet"
msgstr "ยังไม่มีใครสามารถเข้าถึงบัญชีผู้ใช้ของคุณได้"

#: src/modules/dashboard/UserAccess.tsx
msgid "No one has shared access with you yet"
msgstr "ยังไม่มีใครแบ่งปันสิทธิ์การเข้าถึงให้คุณ"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "No payment will be made currently. You can change your payment method at any time."
msgstr "ขณะนี้จะยังไม่มีการชำระเงิน คุณสามารถเปลี่ยนวิธีชำระเงินได้ทุกเมื่อ"

#: src/components/empty.tsx
msgid "No records"
msgstr "ไม่มีรายการ"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "No reservation billing cycles are available for this server."
msgstr "ไม่มีรอบการเรียกเก็บเงินสำหรับการจองที่ใช้ได้สำหรับเซิร์ฟเวอร์นี้"

#: src/components/sidebar/EmptyItem.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/ManagedServices.tsx
msgid "No results found"
msgstr "ไม่พบผลลัพธ์"

#. Short of: Number of storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "No. of buckets"
msgstr "จำนวนบัคเก็ต"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "No. of files"
msgstr "จำนวนไฟล์"

#. Short of: Number of resources
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/NetworkList.tsx
msgid "No. of resources"
msgstr "จำนวนทรัพยากร"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "No. of rules"
msgstr "จำนวนกฎ"

#: src/modules/services/Backups.tsx
#: src/modules/services/Metrics.tsx
msgid "Node"
msgstr "โหนด"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Node pool"
msgstr "Node pool"

#: src/modules/services/ServiceCreate.tsx
msgid "Node pools"
msgstr "Node pools"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "nodes"
msgstr "โหนด"

#. Items: means files or folders
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If you are deleting substantial number of items, the deletion process may result in an inconsistent state, where some items are deleted while others remain. In the event of such occurrences, please repeat the same action again."
msgstr "หมายเหตุ: หากคุณกำลังลบหลายรายการ กระบวนการลบอาจทำให้เกิดสถานะที่ไม่สอดคล้องกัน โดยบางรายการอาจถูกลบแล้ว ขณะที่บางรายการยังคงอยู่ หากเกิดกรณีดังกล่าว โปรดทำรายการเดิมซ้ำอีกครั้ง"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If your folder contains a substantial number of files, the renaming process will take time and may result in an inconsistent state where some files are moved to a new location, while others remain in the old folder. In the event of such occurrences, please repeat the action by renaming the same folder once more."
msgstr "หมายเหตุ: หากโฟลเดอร์ของคุณมีไฟล์จำนวนมาก กระบวนการเปลี่ยนชื่อจะใช้เวลา และอาจทำให้เกิดสถานะที่ไม่สอดคล้องกัน โดยบางไฟล์อาจถูกย้ายไปยังตำแหน่งใหม่ ขณะที่บางไฟล์ยังคงอยู่ในโฟลเดอร์เดิม หากเกิดกรณีดังกล่าว โปรดทำรายการเดิมซ้ำโดยเปลี่ยนชื่อโฟลเดอร์เดียวกันอีกครั้ง"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Note! The owner will know if you have accepted this invitation. They will not be able to access your user account and see or edit any of your resources."
msgstr "หมายเหตุ! เจ้าของจะทราบหากคุณยอมรับคำเชิญนี้ อย่างไรก็ตาม เจ้าของจะไม่สามารถเข้าถึงบัญชีผู้ใช้ของคุณ และไม่สามารถดูหรือแก้ไขทรัพยากรใด ๆ ของคุณได้"

#: src/modules/notifications/NotificationMenu.tsx
msgid "Notifications"
msgstr "การแจ้งเตือน"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Notify when balance goes below"
msgstr "แจ้งเตือนเมื่อยอดคงเหลือต่ำกว่า"

#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Notify when balance goes below the following threshold. Keep in mind that the actual limit is defined in base currency."
msgstr "แจ้งเตือนเมื่อยอดคงเหลือต่ำกว่าค่าขีดจำกัดต่อไปนี้ โปรดทราบว่าค่าขีดจำกัดจริงจะกำหนดตามสกุลเงินหลัก"

#. Availability announcement for AMD EPYC cloud resources
#: src/styles/readyidc/theme.tsx
msgid "Now available"
msgstr "พร้อมให้ใช้งานแล้ว"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Offline"
msgstr "ออฟไลน์"

#. Backup frequency
#: src/modules/services/Backups.tsx
msgid "Once a day"
msgstr "วันละครั้ง"

#: src/modules/compute/VmView.tsx
msgid "Once a week (Wednesday at 02:00 UTC)"
msgstr "สัปดาห์ละครั้ง (วันพุธ เวลา 02:00 UTC)"

#: src/modules/storage/account/SuspendedNotice.tsx
msgid "One of your billing accounts has a problem and your buckets have been suspended. See <0>billing account details</0> for more information or contact support to resolve the issue."
msgstr "หนึ่งในบัญชีการเรียกเก็บเงินของคุณมีปัญหา และบัคเก็ตของคุณถูกระงับการใช้งาน ดู<0>รายละเอียดบัญชีการเรียกเก็บเงิน</0>สำหรับข้อมูลเพิ่มเติม หรือติดต่อฝ่ายสนับสนุนเพื่อแก้ไขปัญหา"

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
msgid "Ongoing"
msgstr "กำลังดำเนินการ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Ongoing balance"
msgstr "ยอดคงเหลือปัจจุบัน"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
msgid "Online"
msgstr "ออนไลน์"

#. Only payment methods that can be charged automatically
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Only automated methods"
msgstr "เฉพาะวิธีอัตโนมัติ"

#: src/modules/compute/VmCreate.tsx
msgid "Only the boot disk will be created! This may cause the OS to not boot properly if the configuration in the OS of source snapshot requires additional disks to be present."
msgstr "จะสร้างเฉพาะดิสก์บูตเท่านั้น! ซึ่งอาจทำให้ระบบปฏิบัติการบูตได้ไม่ถูกต้อง หากการกำหนดค่าในระบบปฏิบัติการของสแนปช็อตต้นทางต้องใช้ดิสก์เพิ่มเติม"

#: src/modules/compute/labels.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Operating system"
msgstr "ระบบปฏิบัติการ"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Operating system Auto update"
msgstr "การอัปเดตระบบปฏิบัติการอัตโนมัติ"

#: src/modules/login/Login.tsx
msgid "Or"
msgstr "หรือ"

#: src/styles/dataxion/theme.tsx
msgid "Order"
msgstr "คำสั่งซื้อ"

#: src/styles/dataxion/theme.tsx
msgid "Orders"
msgstr "คำสั่งซื้อ"

#. Short of: Operating system
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "OS"
msgstr "OS"

#. Short of: outbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "outbound"
msgstr "ขาออก"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Outbound rules"
msgstr "กฎขาออก"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Outgoing traffic is allowed only to the specified ports of the specified destinations. All other traffic will be blocked."
msgstr "ทราฟฟิกขาออกจะได้รับอนุญาตเฉพาะไปยังพอร์ตที่ระบุของปลายทางที่ระบุเท่านั้น ทราฟฟิกอื่นทั้งหมดจะถูกบล็อก"

#: src/modules/billing/BillingList.tsx
msgid "Outstanding amount"
msgstr "ยอดค้างชำระ"

#: src/modules/billing/ReportStatus.tsx
msgid "Paid"
msgstr "ชำระแล้ว"

#: src/modules/services/ConnectionDetails.tsx
msgid "Parameters"
msgstr "พารามิเตอร์"

#: src/modules/compute/PasswordFields.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Password"
msgstr "รหัสผ่าน"

#: src/modules/compute/PasswordFields.tsx
msgid "Password for the user. Must contain at least one lowercase and one uppercase ASCII letter (a-z, A-Z) and at least one digit (0-9). Minimum length is 8 characters."
msgstr "รหัสผ่านสำหรับผู้ใช้ ต้องมีอักษร ASCII ตัวพิมพ์เล็กอย่างน้อยหนึ่งตัว (a-z) และตัวพิมพ์ใหญ่อย่างน้อยหนึ่งตัว (A-Z) และมีตัวเลขอย่างน้อยหนึ่งตัว (0-9) ความยาวขั้นต่ำคือ 8 อักขระ"

#: src/modules/compute/PasswordFields.tsx
msgid "Passwords do not match"
msgstr "รหัสผ่านไม่ตรงกัน"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Past"
msgstr "ที่ผ่านมา"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Path style URL"
msgstr "URL แบบพาธ"

#. Button action: pay for unpaid invoice
#: src/modules/billing/ActionButtons.tsx
msgid "Pay"
msgstr "ชำระเงิน"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Pay invoice"
msgstr "ชำระใบแจ้งหนี้"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Pay now"
msgstr "ชำระเงินตอนนี้"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Pay-as-you-go (recommended)"
msgstr "จ่ายตามการใช้งาน (แนะนำ)"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/paymentMethodLogic.tsx
msgid "Paying by invoice"
msgstr "ชำระเงินด้วยใบแจ้งหนี้"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (declined / suspended)"
msgstr "ชำระเงินด้วยใบแจ้งหนี้ (ถูกปฏิเสธ / ถูกระงับ)"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (pending)"
msgstr "ชำระเงินด้วยใบแจ้งหนี้ (รอดำเนินการ)"

#: src/modules/billing/PaymentReturn.tsx
msgid "Payment authorization check finished."
msgstr "การตรวจสอบการอนุมัติการชำระเงินเสร็จสิ้นแล้ว"

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled"
msgstr "ยกเลิกการชำระเงินแล้ว"

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled due to high risk"
msgstr "การชำระเงินถูกยกเลิกเนื่องจากมีความเสี่ยงสูง"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment details"
msgstr "รายละเอียดการชำระเงิน"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment error"
msgstr "เกิดข้อผิดพลาดในการชำระเงิน"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Payment error: {failure_message}{codeSuffix}"
msgstr "ข้อผิดพลาดในการชำระเงิน: {failure_message}{codeSuffix}"

#: src/modules/billing/clictopay/parseClictopayPaymentResult.ts
#: src/modules/billing/coingate/parseCoingatePaymentResult.ts
#: src/modules/billing/paypal/parsePaypalCheckoutPaymentResult.tsx
#: src/modules/billing/razorpay/parseRazorpayPersistentData.ts
msgid "Payment failed"
msgstr "การชำระเงินล้มเหลว"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment method"
msgstr "วิธีชำระเงิน"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Payment methods"
msgstr "วิธีการชำระเงิน"

#: src/modules/billing/payment_forms/components.tsx
msgid "Payment processing with this method takes some time. Purchased credit will be automatically added to your account once the process is complete."
msgstr "การประมวลผลการชำระเงินด้วยวิธีนี้ใช้เวลาสักครู่ เครดิตที่ซื้อจะถูกเพิ่มเข้าบัญชีของคุณโดยอัตโนมัติเมื่อกระบวนการเสร็จสมบูรณ์"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment type"
msgstr "ประเภทการชำระเงิน"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment was cancelled"
msgstr "การชำระเงินถูกยกเลิก"

#. unit: pieces
#: src/modules/l10n/units.tsx
msgid "pc"
msgstr "ชิ้น"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/metal/status/StatusLabels.tsx
#: src/modules/user/ProfileView.tsx
msgid "Pending"
msgstr "รอดำเนินการ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Period"
msgstr "รอบระยะเวลา"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Permissions"
msgstr "สิทธิ์การเข้าถึง"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Personal ID number"
msgstr "เลขประจำตัวประชาชน"

#: src/modules/billing/omise/OmisePaymentForm.tsx
#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "Phone number"
msgstr "หมายเลขโทรศัพท์"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Platform provided"
msgstr "ที่แพลตฟอร์มจัดเตรียมไว้"

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "Please acknowledge that billing account will not be activated before an administrator has accepted your request."
msgstr "โปรดรับทราบว่าบัญชีการเรียกเก็บเงินจะยังไม่ถูกเปิดใช้งานจนกว่าผู้ดูแลระบบจะอนุมัติคำขอของคุณ"

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Please allow popup windows to use this payment method"
msgstr "โปรดอนุญาตหน้าต่างป๊อปอัปเพื่อใช้วิธีการชำระเงินนี้"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Please be patient"
msgstr "โปรดรอสักครู่"

#: src/modules/billing/progressLabels.tsx
msgid "Please complete the payment in the popup window"
msgstr "กรุณาดำเนินการชำระเงินให้เสร็จสิ้นในหน้าต่างป๊อปอัป"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Please contact support to remove the limit."
msgstr "โปรดติดต่อฝ่ายสนับสนุนเพื่อยกเลิกข้อจำกัด"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please contact the administrators for further details."
msgstr "โปรดติดต่อผู้ดูแลระบบเพื่อขอรายละเอียดเพิ่มเติม"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please continue."
msgstr "โปรดดำเนินการต่อ"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Please enter a valid name"
msgstr "กรุณาระบุชื่อที่ถูกต้อง"

#: src/modules/login/Login.tsx
msgid "Please enter your email address. We will send you an email to reset your password."
msgstr "โปรดกรอกที่อยู่อีเมลของคุณ เราจะส่งอีเมลสำหรับรีเซ็ตรหัสผ่านให้คุณ"

#: src/modules/access/AccessCreate.tsx
msgid "Please finish adding the email"
msgstr "โปรดเพิ่มอีเมลให้เสร็จสิ้น"

#: src/modules/storage/bucket/bucketMessages.tsx
msgid "Please note that the billing account linked to your storage bucket differs from the one associated with your storage account. We highly recommend aligning them for billing consistency and clearer management."
msgstr "โปรดทราบว่าบัญชีเรียกเก็บเงินที่เชื่อมโยงกับบัคเก็ตจัดเก็บข้อมูลของคุณแตกต่างจากบัญชีที่เชื่อมโยงกับบัญชีจัดเก็บข้อมูลของคุณ เราขอแนะนำอย่างยิ่งให้ใช้บัญชีเดียวกันเพื่อให้การเรียกเก็บเงินสอดคล้องกันและจัดการได้ชัดเจนยิ่งขึ้น"

#: src/components/forms/MonthlyCostField.tsx
msgid "Please see how the cost of your resource is calculated."
msgstr "โปรดดูวิธีการคำนวณค่าใช้จ่ายของทรัพยากร"

#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Please select a VPC network to choose target servers from."
msgstr "โปรดเลือกเครือข่าย VPC เพื่อเลือกเซิร์ฟเวอร์เป้าหมาย"

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
msgid "Please select an item in the list"
msgstr "โปรดเลือกรายการจากรายการด้านล่าง"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Please upload a copy of the business registration document or ID card for verification (max {maxFileSizeInMB}MB)."
msgstr "โปรดอัปโหลดสำเนาหนังสือรับรองการจดทะเบียนบริษัทหรือบัตรประจำตัวประชาชนเพื่อใช้ในการตรวจสอบ (สูงสุด {maxFileSizeInMB}MB)"

#: src/modules/services/ServiceView.tsx
msgid "Pods and services hosted on this cluster will be stopped and any ephemeral storage will be discarded."
msgstr "พ็อดและบริการที่โฮสต์อยู่บนคลัสเตอร์นี้จะถูกหยุด และที่เก็บข้อมูลชั่วคราวทั้งหมดจะถูกลบทิ้ง"

#: src/modules/billing/popup/popup.ts
msgid "Popup did not return from redirect"
msgstr "ป๊อปอัปไม่กลับมาหลังจากการเปลี่ยนเส้นทาง"

#: src/modules/billing/popup/popup.ts
msgid "Popup was closed before it could load"
msgstr "ป๊อปอัปถูกปิดก่อนที่จะโหลดเสร็จ"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Port"
msgstr "พอร์ต"

#: src/modules/network/validatePort.ts
msgid "Port must be between 1 and 65535"
msgstr "พอร์ตต้องมีค่าระหว่าง 1 ถึง 65535"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Port range"
msgstr "ช่วงพอร์ต"

#: src/modules/services/ServiceCreate.tsx
msgid "PostgreSQL multi-node setup is a Primary/Standby setup with automatic fail-over."
msgstr "การตั้งค่า PostgreSQL แบบหลายโหนดเป็นการตั้งค่าแบบ Primary/Standby พร้อม Fail-over อัตโนมัติ"

#. Resources attached to the billing account that have already been paid for
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Pre-paid resources"
msgstr "ทรัพยากรที่ชำระเงินล่วงหน้าแล้ว"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Pre-payment"
msgstr "ชำระเงินล่วงหน้า"

#: src/modules/compute/VmList.tsx
msgid "Price"
msgstr "ราคา"

#: src/modules/compute/VmCreate.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Price list"
msgstr "รายการราคา"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Price per cycle"
msgstr "ราคาต่อรอบ"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per hour"
msgstr "ราคาต่อชั่วโมง"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per month"
msgstr "ราคาต่อเดือน"

#: src/modules/pricing/PricingModal.tsx
msgid "Prices may vary for the options below"
msgstr "ราคาสำหรับตัวเลือกด้านล่างอาจแตกต่างกัน"

#. The card that is selected for automatic charging (ie. main)
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
msgid "Primary"
msgstr "หลัก"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Private"
msgstr "ส่วนตัว"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Private images"
msgstr "อิมเมจส่วนตัว"

#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Private IP"
msgstr "IP ส่วนตัว"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceView.tsx
msgid "Private IPv4"
msgstr "IPv4 ส่วนตัว"

#: src/modules/services/Networking.tsx
msgid "Private network"
msgstr "เครือข่ายส่วนตัว"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Problem with PayPal API."
msgstr "เกิดปัญหากับ API ของ PayPal"

#: src/modules/user/ProfileView.tsx
#: src/modules/user/UserMenu.tsx
msgid "Profile"
msgstr "โปรไฟล์"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Protocol"
msgstr "โปรโตคอล"

#: src/modules/compute/VmCreate.tsx
msgid "Provide a valid cloud-config as JSON or YAML. This configuration will be passed as cloud-init user-data to the virtual machine. See cloud-init documentation about cloud-config for all the available options."
msgstr "ระบุ cloud-config ที่ถูกต้องในรูปแบบ JSON หรือ YAML การกำหนดค่านี้จะถูกส่งไปยังเครื่องเสมือนในรูปแบบ user-data ของ cloud-init โปรดดูเอกสารของ cloud-init เกี่ยวกับ cloud-config สำหรับตัวเลือกที่มีทั้งหมด"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Provider start of maintenance time window in which Provider may schedule automated cluster updates."
msgstr "เวลาเริ่มต้นของช่วงเวลาบำรุงรักษาที่ผู้ให้บริการอาจใช้กำหนดเวลาการอัปเดตคลัสเตอร์อัตโนมัติ"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public"
msgstr "สาธารณะ"

#: src/components/table/DetailsTableIpAddress.tsx
msgid "Public IP addresses are managed in the Network view."
msgstr "ที่อยู่ IP สาธารณะจะจัดการได้ในมุมมองเครือข่าย"

#: src/components/table/DetailsTableIpAddress.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv4"
msgstr "IPv4 สาธารณะ"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv6"
msgstr "IPv6 สาธารณะ"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/user/ProfileView.tsx
msgid "Public key"
msgstr "กุญแจสาธารณะ"

#: src/modules/compute/labels.tsx
msgid "Public key part of the SSH key pair for logging in to the VM. Must be in format <0>ssh-key-type base64encoded...key optional_comment</0>."
msgstr "ส่วนคีย์สาธารณะของคู่คีย์ SSH สำหรับเข้าสู่ระบบ VM ต้องอยู่ในรูปแบบ <0>ssh-key-type base64encoded...key optional_comment</0>"

#: src/modules/services/ConnectionDetails.tsx
msgid "Public network"
msgstr "เครือข่ายสาธารณะ"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public URL"
msgstr "URL สาธารณะ"

#. Short of: Quantity
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Qty."
msgstr "จำนวน"

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "quarter"
msgstr "ไตรมาส"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Quarterly"
msgstr "รายไตรมาส"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MetricsGrid.tsx
msgid "RAM"
msgstr "RAM"

#: src/modules/compute/VmToolbar.tsx
msgid "RDP link"
msgstr "ลิงก์ RDP"

#: src/modules/services/ServiceView.tsx
msgid "Read more"
msgstr "อ่านเพิ่มเติม"

#. Only read permissions
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Read-only"
msgstr "อ่านอย่างเดียว"

#: src/modules/services/ServiceView.tsx
msgid "Readiness"
msgstr "ความพร้อม"

#: src/modules/metal/os/MetalOsSelect.tsx
msgid "Ready"
msgstr "พร้อมใช้งาน"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Reboot"
msgstr "รีบูต"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Recent"
msgstr "ล่าสุด"

#: src/modules/billing/progressLabels.tsx
msgid "Redirecting to payment gateway"
msgstr "กำลังเปลี่ยนเส้นทางไปยังช่องทางการชำระเงิน"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral code"
msgstr "รหัสแนะนำ"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral link"
msgstr "ลิงก์แนะนำ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral program"
msgstr "โปรแกรมแนะนำเพื่อน"

#: src/modules/billing/account_validation/RefreshStatusButton.tsx
msgid "Refresh status"
msgstr "รีเฟรชสถานะ"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Registration number"
msgstr "เลขทะเบียน"

#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstall"
msgstr "ติดตั้งใหม่"

#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstalling \"{name}\" will destroy all data on the boot disk and set it to the initial clean OS state. All snapshots and backups are preserved."
msgstr "การติดตั้ง \"{name}\" ใหม่จะลบข้อมูลทั้งหมดบนดิสก์บูต และรีเซ็ตให้กลับสู่สถานะเริ่มต้นของระบบปฏิบัติการที่สะอาด โดยจะยังคงเก็บสแนปช็อตและข้อมูลสำรองทั้งหมดไว้"

#: src/components/sidebar/ListErrorBoundary.tsx
msgid "Reload"
msgstr "โหลดใหม่"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Reload data"
msgstr "โหลดข้อมูลใหม่"

#: src/root.tsx
msgid "Reload page"
msgstr "โหลดหน้าใหม่"

#: src/modules/billing/PaymentTopItem.tsx
msgid "Remaining credit <0/>"
msgstr "เครดิตคงเหลือ <0/>"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Remove resource"
msgstr "นำทรัพยากรออก"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Removing the public IPv4 address assignment from this resource will make the resource inaccessible from the public Internet. The IP address will remain reserved to your account. You can manage public IPv4 addresses from the Network menu on the left sidebar."
msgstr "การยกเลิกการกำหนดที่อยู่ IPv4 สาธารณะออกจากทรัพยากรนี้ จะทำให้ไม่สามารถเข้าถึงทรัพยากรนี้จากอินเทอร์เน็ตสาธารณะได้ ที่อยู่ IP จะยังคงถูกสำรองไว้ให้กับบัญชีของคุณ คุณสามารถจัดการที่อยู่ IPv4 สาธารณะได้จากเมนูเครือข่ายในแถบด้านซ้าย"

#. placeholder {0}: item.grantee_username
#: src/modules/access/delegation/DelegationView.tsx
msgid "Removing user will revoke the rights from \"{0}\" to act as you."
msgstr "การลบผู้ใช้จะเป็นการเพิกถอนสิทธิ์ของ \"{0}\" ในการดำเนินการในนามของคุณ"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Rename"
msgstr "เปลี่ยนชื่อ"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Report"
msgstr "รายงาน"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Report {id}"
msgstr "รายงาน {id}"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reports"
msgstr "รายงาน"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Requested"
msgstr "ส่งคำขอแล้ว"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Reservations"
msgstr "การจอง"

#. Disk status
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Reserved"
msgstr "สำรองไว้"

#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Reserved and prepaid until <0/> ({daysRemaining} days remaining). Price shown as a monthly equivalent."
msgstr "จองและชำระล่วงหน้าจนถึง <0/> (เหลืออีก {daysRemaining} วัน) ราคาแสดงเป็นอัตราเทียบเท่ารายเดือน"

#: src/modules/user/ProfileView.tsx
msgid "Reset password"
msgstr "รีเซ็ตรหัสผ่าน"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Resize"
msgstr "ปรับขนาด"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Resize disk"
msgstr "ปรับขนาดดิสก์"

#: src/modules/compute/VmResizeModal.tsx
msgid "Resizing is only possible when the virtual machine is stopped."
msgstr "การปรับขนาดทำได้เฉพาะเมื่อเครื่องเสมือนอยู่ในสถานะหยุดทำงาน"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Resource name"
msgstr "ชื่อทรัพยากร"

#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Resources"
msgstr "ทรัพยากร"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the same VPC network using private addresses of primary interfaces"
msgstr "ทรัพยากรในเครือข่าย VPC เดียวกัน โดยใช้ที่อยู่ส่วนตัวของอินเทอร์เฟซหลัก"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the VPCs shared by VLAN sub-interfaces using their respective private address"
msgstr "ทรัพยากรใน VPC ที่ใช้ร่วมกันผ่านอินเทอร์เฟซย่อย VLAN โดยใช้ที่อยู่ส่วนตัวของแต่ละอินเทอร์เฟซ"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Response seems to be taking longer than expected. Wait a bit and refresh the page to see changes reflected. The result might be either successful or unsuccessful."
msgstr "การตอบกลับใช้เวลานานกว่าที่คาดไว้ กรุณารอสักครู่แล้วรีเฟรชหน้าเพื่อดูการเปลี่ยนแปลง ผลลัพธ์อาจสำเร็จหรือไม่สำเร็จก็ได้"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Response seems to be taking more time than expected. Wait a bit and refresh the page to see payment status changes reflected. If it doesn't happen in a reasonable time, please contact support."
msgstr "การตอบกลับดูเหมือนจะใช้เวลานานกว่าที่คาดไว้ โปรดรอสักครู่แล้วรีเฟรชหน้าเพื่อดูการเปลี่ยนแปลงของสถานะการชำระเงิน หากยังไม่เกิดขึ้นภายในเวลาที่เหมาะสม โปรดติดต่อฝ่ายสนับสนุน"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/Backups.tsx
msgid "Restore"
msgstr "กู้คืน"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
msgid "Restore from backup"
msgstr "กู้คืนจากข้อมูลสำรอง"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restore from snapshot"
msgstr "กู้คืนจากสแนปช็อต"

#: src/modules/services/Backups.tsx
msgid "Restoring from a backup will overwrite the service's state with the selected backup's state."
msgstr "การกู้คืนจากข้อมูลสำรองจะเขียนทับสถานะของบริการด้วยสถานะจากข้อมูลสำรองที่เลือก"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this backup will overwrite the current state."
msgstr "การกู้คืนข้อมูลสำรองนี้จะเขียนทับสถานะปัจจุบัน"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this snapshot will overwrite the current state."
msgstr "การกู้คืนสแนปช็อตนี้จะเขียนทับสถานะปัจจุบัน"

#: src/modules/access/scopeLabel.tsx
msgid "Restricted"
msgstr "จำกัด"

#: src/modules/compute/VmView.tsx
msgid "Retention"
msgstr "ระยะเวลาเก็บรักษา"

#. Button action
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/notifications/toast.tsx
msgid "Retry"
msgstr "ลองอีกครั้ง"

#: src/styles/readyidc/theme.tsx
msgid "Revolutionize your cloud with AMD EPYC"
msgstr "ยกระดับคลาวด์ของคุณด้วย AMD EPYC"

#. Registre National des Entreprises (RNE) company registration document
#: src/styles/dataxion/theme.tsx
msgid "RNE document"
msgstr "เอกสาร RNE"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Rules from all attached firewalls are combined, a connection is allowed if there is at least one rule that allows it."
msgstr "กฎจากไฟร์วอลล์ที่เชื่อมต่อทั้งหมดจะถูกรวมกัน โดยจะอนุญาตการเชื่อมต่อหากมีกฎอย่างน้อยหนึ่งข้อที่อนุญาต"

#: src/modules/metal/MetalCreate.tsx
msgid "Run your applications on Bare Metal Servers for full control, security, and raw performance. Provision a dedicated server optimized for your most demanding use cases."
msgstr "รันแอปพลิเคชันของคุณบนเซิร์ฟเวอร์ Bare Metal เพื่อการควบคุมอย่างเต็มที่ ความปลอดภัย และประสิทธิภาพสูงสุด จัดเตรียมเซิร์ฟเวอร์เฉพาะที่ปรับแต่งมาให้เหมาะกับงานที่ต้องการประสิทธิภาพสูงที่สุดของคุณ"

#. Virtual machine status
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/monitor/MetricChart.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Running"
msgstr "กำลังทำงาน"

#: src/modules/storage/StorageCreate.tsx
msgid "S3-compatible object storage allows you to scale your storage resources up and down without any upfront payments. Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "ที่เก็บข้อมูลแบบอ็อบเจ็กต์ที่รองรับ S3 ช่วยให้คุณเพิ่มหรือลดทรัพยากรพื้นที่จัดเก็บได้ตามต้องการโดยไม่ต้องชำระล่วงหน้า สร้างบัญชีจัดเก็บข้อมูลใหม่ สร้างบัคเก็ตบางส่วน และเริ่มจัดเก็บข้อมูลของคุณได้อย่างยืดหยุ่น พร้อมจ่ายตามการใช้งานที่เพิ่มขึ้น"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Save"
msgstr "บันทึก"

#: src/modules/billing/progressLabels.tsx
msgid "Saving payment information"
msgstr "กำลังบันทึกข้อมูลการชำระเงิน"

#: src/modules/billing/QrCodeDisplay.tsx
msgid "Scan the QR code to pay"
msgstr "สแกนคิวอาร์โค้ดเพื่อชำระเงิน"

#: src/modules/access/AccessCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "Scope"
msgstr "ขอบเขต"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Search"
msgstr "ค้นหา"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Secret access key"
msgstr "คีย์การเข้าถึงลับ"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Select a file"
msgstr "เลือกไฟล์"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Select a payment method"
msgstr "เลือกวิธีชำระเงิน"

#: src/components/forms/WSelect.tsx
msgid "Select an option"
msgstr "เลือกตัวเลือก"

#. placeholder {0}: siteCurrencyInfo.title
#: src/modules/currency/CurrencyModal.tsx
msgid "Select your display currency to view prices in your preferred currency. Displayed amounts and exchange rates are indicative and for informational purposes only. All transactions are processed in the underlying currency ({0}), and final charges may vary based on your payment provider's rates."
msgstr "เลือกสกุลเงินที่ใช้แสดงราคาเพื่อดูราคาในสกุลเงินที่คุณต้องการ จำนวนเงินและอัตราแลกเปลี่ยนที่แสดงเป็นเพียงค่าโดยประมาณและมีไว้เพื่อการให้ข้อมูลเท่านั้น ธุรกรรมทั้งหมดจะดำเนินการในสกุลเงินหลัก ({0}) และยอดเรียกเก็บสุดท้ายอาจแตกต่างกันตามอัตราของผู้ให้บริการชำระเงินของคุณ"

#: src/modules/currency/CurrencyModal.tsx
msgid "Select your preferred currency"
msgstr "เลือกสกุลเงินที่คุณต้องการ"

#: src/modules/compute/WVnc.tsx
msgid "Send Ctrl+Alt+Del"
msgstr "ส่ง Ctrl+Alt+Del"

#: src/modules/login/Login.tsx
msgid "Send email"
msgstr "ส่งอีเมล"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Server"
msgstr "เซิร์ฟเวอร์"

#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Server class"
msgstr "คลาสเซิร์ฟเวอร์"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
msgid "Service"
msgstr "บริการ"

#: src/modules/services/ServiceCreate.tsx
msgid "Service name"
msgstr "ชื่อบริการ"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/ServicesList.tsx
msgid "Services"
msgstr "บริการ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Set default"
msgstr "ตั้งเป็นค่าเริ่มต้น"

#. 'private' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'private'"
msgstr "ตั้งค่า ACL ของออบเจ็กต์เป็น 'private'"

#. 'public-read' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'public-read'"
msgstr "ตั้งค่า ACL ของออบเจ็กต์เป็น 'public-read'"

#. Button action
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "Share access"
msgstr "แบ่งปันสิทธิ์การเข้าถึง"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on Facebook"
msgstr "แชร์บน Facebook"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on LinkedIn"
msgstr "แชร์บน LinkedIn"

#. X is the social network
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on X"
msgstr "แชร์บน X"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Share temporarily"
msgstr "แชร์ชั่วคราว"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sharing duration"
msgstr "ระยะเวลาการแชร์"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Show"
msgstr "แสดง"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Show details"
msgstr "แสดงรายละเอียด"

#. An item is any kind of resource being managed (e.g. VM, disk, bucket, etc).
#: src/modules/dashboard/RecentlyModified.tsx
msgid "Showing {limit} latest items"
msgstr "แสดง {limit} รายการล่าสุด"

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Showing list prices. Discount applied in the cost summary."
msgstr "กำลังแสดงราคาตามรายการ โดยจะใช้ส่วนลดในสรุปค่าใช้จ่าย"

#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Sign up"
msgstr "สมัครสมาชิก"

#: src/modules/login/Login.tsx
msgid "Sign up with Google"
msgstr "สมัครสมาชิกด้วย Google"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
msgid "Size"
msgstr "ขนาด"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Size (GB)"
msgstr "ขนาด (GB)"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Snapshots"
msgstr "สแนปช็อต"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Social share"
msgstr "แชร์บนโซเชียล"

#: src/modules/metal/spec/SpecRadio.tsx
msgid "Sold out"
msgstr "หมด"

#. Label for dropdown menu that selects by what files are sorted. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort"
msgstr "จัดเรียง"

#: src/components/sidebar/SortMenu.tsx
msgid "Sort by"
msgstr "เรียงตาม"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by date"
msgstr "จัดเรียงตามวันที่"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by name"
msgstr "จัดเรียงตามชื่อ"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by size"
msgstr "จัดเรียงตามขนาด"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
msgid "Source port"
msgstr "พอร์ตต้นทาง"

#: src/modules/network/loadbalancer/validatePorts.ts
msgid "Source port must be unique"
msgstr "พอร์ตต้นทางต้องไม่ซ้ำกัน"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Sources"
msgstr "ต้นทาง"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "SSH key does not match required pattern"
msgstr "คีย์ SSH ไม่ตรงตามรูปแบบที่กำหนด"

#: src/modules/compute/VmCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "SSH keys"
msgstr "กุญแจ SSH"

#: src/modules/compute/VmCreate.tsx
msgid "SSH keys can be managed under your <0>user profile</0>."
msgstr "คุณสามารถจัดการกุญแจ SSH ได้ใน<0>โปรไฟล์ผู้ใช้</0>ของคุณ"

#: src/modules/compute/VmToolbar.tsx
msgid "SSH link"
msgstr "ลิงก์ SSH"

#: src/modules/compute/VmRootUserWarning.tsx
msgid "SSH might not be available for root user due to operating system initial setup. Please use virtual console to access the system and make the SSH server config changes according to your needs."
msgstr "SSH อาจยังไม่พร้อมใช้งานสำหรับผู้ใช้ root เนื่องจากการตั้งค่าเริ่มต้นของระบบปฏิบัติการ โปรดใช้คอนโซลเสมือนเพื่อเข้าถึงระบบ และปรับการตั้งค่าเซิร์ฟเวอร์ SSH ตามความต้องการของคุณ"

#. Button action
#: src/modules/compute/BootFromIsoModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/support/WChatProvider.tsx
#: src/modules/user/ActAsModal.tsx
msgid "Start"
msgstr "เริ่ม"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Start date"
msgstr "วันที่เริ่มต้น"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
msgid "Start here"
msgstr "เริ่มที่นี่"

#: src/modules/network/NetworkCreate.tsx
msgid "Start managing your networks by creating a new network resource."
msgstr "เริ่มจัดการเครือข่ายของคุณด้วยการสร้างทรัพยากรเครือข่ายใหม่"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Start port"
msgstr "พอร์ตเริ่มต้น"

#: src/modules/network/firewall/validatePorts.ts
msgid "Start port must be unique"
msgstr "พอร์ตเริ่มต้นต้องไม่ซ้ำกัน"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Start something new"
msgstr "เริ่มต้นสิ่งใหม่"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Start time"
msgstr "เวลาเริ่มต้น"

#: src/modules/billing/progressLabels.tsx
msgid "Starting payment"
msgstr "กำลังเริ่มชำระเงิน"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "State"
msgstr "รัฐ/จังหวัด"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Status"
msgstr "สถานะ"

#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Stop"
msgstr "หยุด"

#. Virtual machine status
#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Stopped"
msgstr "หยุดทำงาน"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
msgid "Stopping"
msgstr "กำลังหยุด"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/storage/StorageList.tsx
msgid "Storage"
msgstr "ที่จัดเก็บข้อมูล"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage access keys"
msgstr "คีย์การเข้าถึงที่เก็บข้อมูล"

#: src/modules/api/resourceTypes.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Storage account"
msgstr "บัญชีจัดเก็บข้อมูล"

#: src/modules/api/resourceTypes.tsx
msgid "Storage bucket"
msgstr "บัคเก็ตจัดเก็บข้อมูล"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Storage bucket name"
msgstr "ชื่อบัคเก็ตจัดเก็บข้อมูล"

#. List of S3 storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage buckets"
msgstr "บัคเก็ตจัดเก็บข้อมูล"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Street address"
msgstr "ที่อยู่"

#: src/modules/services/ConnectionDetails.tsx
msgid "String"
msgstr "สตริง"

#: src/modules/network/NetworkCreate.tsx
msgid "Subnet range (CIDR)"
msgstr "ช่วงซับเน็ต (CIDR)"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal"
msgstr "ยอดรวมย่อย"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal before discounts"
msgstr ""

#. Button label. Short of: Contact customer support
#: src/modules/main/TopNav.tsx
msgid "Support"
msgstr "ฝ่ายสนับสนุน"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Suspended"
msgstr "ระงับ"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to Grid view"
msgstr "สลับเป็นมุมมองแบบตาราง"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to List view"
msgstr "สลับเป็นมุมมองแบบรายการ"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "system"
msgstr "ระบบ"

#: src/modules/compute/labels.tsx
msgid "Take a snapshot to create an instant image of your virtual machine's current state. You can later use the snapshot to restore your virtual machine state or create a new virtual machine from the snapshot with modified size parameters."
msgstr "สร้างสแนปช็อตเพื่อสร้างอิมเมจทันทีของสถานะปัจจุบันของเครื่องเสมือนของคุณ ภายหลังคุณสามารถใช้สแนปช็อตเพื่อกู้คืนสถานะของเครื่องเสมือน หรือสร้างเครื่องเสมือนใหม่จากสแนปช็อตโดยปรับพารามิเตอร์ขนาดได้"

#: src/modules/compute/VmView.tsx
msgid "Take snapshot"
msgstr "สร้างสแนปช็อต"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Take some action and you'll never see this cactus again."
msgstr "ลองดำเนินการบางอย่าง แล้วคุณจะไม่เห็นกระบองเพชรนี้อีก"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Target port"
msgstr "พอร์ตปลายทาง"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Target servers"
msgstr "เซิร์ฟเวอร์เป้าหมาย"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/WVnc.tsx
msgid "Terminal"
msgstr "คอนโซล"

#: src/modules/login/ConsentForm.tsx
msgid "Terms of Service"
msgstr "ข้อกำหนดในการให้บริการ"

#: src/modules/pricing/PricingModal.tsx
msgid "The actual cost of your resource is calculated based on the below prices and your actual hourly usage. All prices are per one unit of resource (1 vCPU or 1 GiB). Prices do not contain taxes."
msgstr "ค่าใช้จ่ายจริงของทรัพยากรจะคำนวณจากราคาด้านล่างและการใช้งานจริงรายชั่วโมงของคุณ ราคาทั้งหมดคิดต่อทรัพยากร 1 หน่วย (1 vCPU หรือ 1 GiB) ราคายังไม่รวมภาษี"

#: src/modules/billing/forms/BillingSelect.tsx
msgid "The billing account has been closed and is no longer available."
msgstr "บัญชีการเรียกเก็บเงินนี้ถูกปิดแล้วและไม่สามารถใช้งานได้อีก"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "The campaign code is activated only after a successful top up."
msgstr "รหัสแคมเปญจะเปิดใช้งานได้หลังจากเติมเงินสำเร็จเท่านั้น"

#: src/modules/user/ActAsModal.tsx
msgid "The entire user interface will switch and act as you were that user. Once you are finished you can stop the session by clicking “Back to your account” button on the header bar and the user interface will switch back to your account."
msgstr "อินเทอร์เฟซผู้ใช้ทั้งหมดจะสลับไปและทำงานเสมือนว่าคุณเป็นผู้ใช้นั้น เมื่อคุณใช้งานเสร็จแล้ว คุณสามารถสิ้นสุดเซสชันได้โดยคลิกปุ่ม “Back to your account” บนแถบส่วนหัว แล้วอินเทอร์เฟซผู้ใช้จะสลับกลับมายังบัญชีของคุณ"

#: src/modules/billing/ConversionMessage.tsx
msgid "The final exchange rate and charge amount will be determined at the moment of actual payment."
msgstr "อัตราแลกเปลี่ยนและยอดเรียกเก็บเงินสุดท้ายจะถูกกำหนดในขณะที่มีการชำระเงินจริง"

#: src/modules/billing/promotionNotices.tsx
msgid "The first top up will unlock your complimentary free credit of <0><1/></0>."
msgstr "การเติมเงินครั้งแรกจะปลดล็อกเครดิตฟรีมูลค่า <0><1/></0> สำหรับคุณ"

#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "The format is MM/YY"
msgstr "รูปแบบคือ MM/YY"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "The link expires on:"
msgstr "ลิงก์จะหมดอายุเมื่อ:"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "The name can only contain lowercase alphanumeric characters and dashes, it must start with a lowercase letter or number, the allowed length is 3–63."
msgstr "ชื่อต้องประกอบด้วยตัวอักษรพิมพ์เล็ก ตัวเลข และขีดกลาง (-) เท่านั้น โดยต้องขึ้นต้นด้วยตัวอักษรพิมพ์เล็กหรือตัวเลข และมีความยาวได้ 3–63 อักขระ"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The password can be changed for any existing user account."
msgstr "สามารถเปลี่ยนรหัสผ่านให้กับบัญชีผู้ใช้ที่มีอยู่ได้ทุกบัญชี"

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "The phone/mobile number to contact if any issue arises"
msgstr "หมายเลขโทรศัพท์/โทรศัพท์มือถือสำหรับติดต่อหากเกิดปัญหา"

#: src/components/forms/MonthlyCostField.tsx
msgid "The price is approximate, the cost of your resource will be calculated based on your actual hourly usage."
msgstr "ราคานี้เป็นราคาโดยประมาณ ค่าใช้จ่ายของทรัพยากรจะคำนวณตามการใช้งานจริงรายชั่วโมง"

#: src/modules/compute/PasswordFields.tsx
msgid "The re-typed password, to ensure that it has been entered correctly."
msgstr "รหัสผ่านที่พิมพ์ซ้ำอีกครั้ง เพื่อยืนยันว่าป้อนถูกต้อง"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account does not have enough credit to purchase this reservation."
msgstr "บัญชีเรียกเก็บเงินที่เลือกมีเครดิตไม่เพียงพอสำหรับซื้อการจองนี้"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account is limited and can not create reservations."
msgstr "บัญชีเรียกเก็บเงินที่เลือกเป็นบัญชีแบบจำกัดและไม่สามารถสร้างการจองได้"

#: src/modules/network/NetworkCreate.tsx
msgid "The subnet must fall within one the following IP blocks:"
msgstr "ซับเน็ตต้องอยู่ภายในบล็อก IP ต่อไปนี้อย่างใดอย่างหนึ่ง:"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The user account for which password will be set."
msgstr "บัญชีผู้ใช้ที่จะตั้งรหัสผ่าน"

#: src/modules/login/Login.tsx
msgid "There was an error verifying your email address."
msgstr "เกิดข้อผิดพลาดในการยืนยันที่อยู่อีเมลของคุณ"

#: src/components/sidebar/ErrorItem.tsx
msgid "There was an error while creating your resource."
msgstr "เกิดข้อผิดพลาดขณะสร้างทรัพยากรของคุณ"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "These credentials are only for the initial login. It is recommended to change these immediately."
msgstr "ข้อมูลรับรองเหล่านี้ใช้สำหรับการเข้าสู่ระบบครั้งแรกเท่านั้น แนะนำให้เปลี่ยนทันที"

#. This resource was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This {resourceTypeName} is gone"
msgstr "{resourceTypeName} นี้ไม่มีอยู่แล้ว"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "This bare metal server is still being set up."
msgstr "เซิร์ฟเวอร์ Bare Metal นี้ยังอยู่ระหว่างการตั้งค่า"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "This billing account has limited capabilities when creating resources."
msgstr "บัญชีการเรียกเก็บเงินนี้มีข้อจำกัดในการสร้างทรัพยากร"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "This billing account is limited"
msgstr "บัญชีการเรียกเก็บเงินนี้เป็นแบบจำกัด"

#: src/modules/compute/VmCreate.tsx
msgid "This distribution adds a <0/> cost per hour for licensing (<1/> per month)."
msgstr "ดิสทริบิวชันนี้มีค่าใช้จ่ายเพิ่มเติมสำหรับไลเซนส์ <0/> ต่อชั่วโมง (<1/> ต่อเดือน)"

#: src/components/forms/requiredMessage.tsx
msgid "This field is required"
msgstr "จำเป็นต้องกรอกข้อมูลในช่องนี้"

#: src/modules/storage/account/CreateKeyModal.tsx
msgid "This key has access to all buckets under this storage account. To restrict access to specific buckets, create a separate storage account."
msgstr "คีย์นี้สามารถเข้าถึงบัคเก็ตทั้งหมดภายใต้บัญชีจัดเก็บข้อมูลนี้ หากต้องการจำกัดการเข้าถึงเฉพาะบัคเก็ต ให้สร้างบัญชีจัดเก็บข้อมูลแยกต่างหาก"

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This page is gone"
msgstr "หน้านี้ไม่มีอยู่แล้ว"

#: src/modules/services/Access.tsx
#: src/modules/services/Networking.tsx
msgid "This service is accessible only by resources in the same VPC network using these private addresses."
msgstr "บริการนี้สามารถเข้าถึงได้เฉพาะจากทรัพยากรในเครือข่าย VPC เดียวกันโดยใช้ที่อยู่ส่วนตัวเหล่านี้"

#: src/modules/compute/VmView.tsx
msgid "This virtual machine is accessible by:"
msgstr "เครื่องเสมือนนี้สามารถเข้าถึงได้โดย:"

#: src/modules/network/firewall/FirewallDeleteModal.tsx
msgid "This will delete the firewall and its associated rules, and they will no longer apply to any assigned resources."
msgstr "การดำเนินการนี้จะลบไฟร์วอลล์และกฎที่เกี่ยวข้อง และกฎเหล่านั้นจะไม่มีผลกับทรัพยากรที่กำหนดไว้ใด ๆ อีกต่อไป"

#: src/modules/compute/VmToolbar.tsx
msgid "This will forcefully shut down your resource \"{name}\". For stopped resources you will only be charged for the storage."
msgstr "การดำเนินการนี้จะบังคับปิดทรัพยากร \"{name}\" ของคุณ สำหรับทรัพยากรที่หยุดอยู่ คุณจะถูกเรียกเก็บเงินเฉพาะค่าพื้นที่จัดเก็บข้อมูลเท่านั้น"

#: src/modules/services/ServiceView.tsx
msgid "This will hibernate cluster \"{display_name}\"."
msgstr "การดำเนินการนี้จะไฮเบอร์เนตคลัสเตอร์ \"{display_name}\""

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "This will only be used within the system so it's easy for you to recognize the account if you have several."
msgstr "ชื่อนี้จะใช้ภายในระบบเท่านั้น เพื่อให้คุณแยกแยะบัญชีได้ง่ายหากมีหลายบัญชี"

#: src/modules/compute/VmToolbar.tsx
msgid "This will reboot your resource \"{name}\"."
msgstr "การดำเนินการนี้จะรีบูตทรัพยากร \"{name}\" ของคุณ"

#: src/modules/services/IpWhitelist.tsx
msgid "This will remove the address or range from the allowlist.<0/>Note that an empty allowlist will permit connections from any address."
msgstr "การดำเนินการนี้จะลบที่อยู่หรือช่วงที่อยู่ออกจากรายการที่อนุญาต<0/>โปรดทราบว่าหากรายการที่อนุญาตว่างอยู่ ระบบจะอนุญาตการเชื่อมต่อจากทุกที่อยู่"

#: src/modules/services/ServiceView.tsx
msgid "This will shut down your resource \"{display_name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "การดำเนินการนี้จะปิดทรัพยากร \"{display_name}\" ของคุณ หากการปิดระบบอย่างปลอดภัยไม่เสร็จสิ้นภายใน 120 วินาที ระบบจะทำการบังคับหยุด สำหรับทรัพยากรที่ถูกหยุด คุณจะถูกเรียกเก็บเงินเฉพาะส่วนของพื้นที่จัดเก็บข้อมูลเท่านั้น"

#: src/modules/compute/VmToolbar.tsx
msgid "This will shut down your resource \"{name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "การดำเนินการนี้จะปิดทรัพยากร \"{name}\" ของคุณ หากการปิดระบบอย่างถูกต้องไม่เสร็จสิ้นภายใน 120 วินาที ระบบจะทำการบังคับหยุด สำหรับทรัพยากรที่หยุดอยู่ คุณจะถูกเรียกเก็บเงินเฉพาะค่าพื้นที่จัดเก็บข้อมูลเท่านั้น"

#: src/modules/network/loadbalancer/LoadBalancerDeleteModal.tsx
msgid "This will stop forwarding traffic to the targets and remove the load balancer."
msgstr "การดำเนินการนี้จะหยุดส่งต่อทราฟฟิกไปยังเป้าหมายและลบโหลดบาลานเซอร์"

#. Amount below which a low balance notification will be sent
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Threshold"
msgstr "ค่าขีดจำกัด"

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. Here are some ideas where to go next:"
msgstr "ไปต่อกันได้เลย ต่อไปนี้คือตัวเลือกที่คุณอาจต้องการ:"

#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. This item is deleted or you do not have access."
msgstr "ไปต่อกันได้เลย รายการนี้ถูกลบไปแล้ว หรือคุณไม่มีสิทธิ์เข้าถึง"

#: src/modules/billing/razorpay/RazorpayPaymentForm.tsx
msgid "Timed out waiting for a response from Razorpay"
msgstr "หมดเวลารอการตอบกลับจาก Razorpay"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Timezone"
msgstr "เขตเวลา"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "To activate a billing account, please add a credit card as a payment method or contact support to enable invoice payments."
msgstr "หากต้องการเปิดใช้งานบัญชีการเรียกเก็บเงิน โปรดเพิ่มบัตรเครดิตเป็นวิธีการชำระเงิน หรือติดต่อฝ่ายสนับสนุนเพื่อเปิดใช้งานการชำระเงินด้วยใบแจ้งหนี้"

#: src/modules/services/IpWhitelist.tsx
msgid "To restrict connections to the service you have to add at least one inbound IP to the allowlist (All other public and private connections will be denied). You can specify a single IPv4 address or a block of addresses using CIDR notation (e.g. 1.1.1.0/24)"
msgstr "หากต้องการจำกัดการเชื่อมต่อไปยังบริการ คุณต้องเพิ่ม IP ขาเข้าอย่างน้อยหนึ่งรายการลงในรายการที่อนุญาต (การเชื่อมต่อสาธารณะและส่วนตัวอื่นทั้งหมดจะถูกปฏิเสธ) คุณสามารถระบุที่อยู่ IPv4 เดี่ยวหรือช่วงของที่อยู่โดยใช้รูปแบบ CIDR (เช่น 1.1.1.0/24)"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/WelcomeModal.tsx
msgid "To start using the platform you need to first setup billing account. You are welcome to click around to familiarize yourself with the system and come back to billing account creation at any time you are ready to start building your first resources."
msgstr "หากต้องการเริ่มใช้งานแพลตฟอร์ม คุณต้องตั้งค่าบัญชีการเรียกเก็บเงินก่อน คุณสามารถทดลองใช้งานส่วนต่าง ๆ เพื่อทำความคุ้นเคยกับระบบได้ และกลับมาสร้างบัญชีการเรียกเก็บเงินเมื่อคุณพร้อมเริ่มสร้างทรัพยากรแรกของคุณ"

#: src/modules/login/ConsentForm.tsx
msgid "To use our services, you need to agree to the Terms of Service."
msgstr "หากต้องการใช้บริการของเรา คุณต้องยอมรับข้อกำหนดในการให้บริการ"

#: src/modules/access/token/TokenView.tsx
msgid "Token"
msgstr "โทเค็น"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up"
msgstr "เติมเงิน"

#. How much to top up | POS: Noun
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Top up amount"
msgstr "จำนวนเงินที่เติม"

#: src/modules/billing/promotionNotices.tsx
msgid "Top up at least <0><1/></0> to obtain <2><3/></2> of referral code bonus."
msgstr "เติมเงินอย่างน้อย <0><1/></0> เพื่อรับโบนัสจากรหัสแนะนำมูลค่า <2><3/></2>"

#: src/modules/billing/ActionButtons.tsx
msgid "Top up now"
msgstr "เติมเงินตอนนี้"

#. Top up your billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up your account"
msgstr "เติมเงินเข้าบัญชีของคุณ"

#. Invoices for billing account top-ups
#: src/components/themeTrans.tsx
msgid "Top-up invoices"
msgstr "ใบแจ้งหนี้การเติมเงิน"

#: src/styles/dataxion/theme.tsx
msgid "Top-up orders"
msgstr "คำสั่งซื้อเติมเงิน"

#. Total amount of the invoice
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Total"
msgstr "ยอดรวม"

#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Total charge"
msgstr "ยอดเรียกเก็บทั้งหมด"

#. Short of: Total excluding
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Total excl. {vatSymbol}"
msgstr "ยอดรวมไม่รวม {vatSymbol}"

#: src/components/themeTrans.tsx
msgid "Total of all unpaid invoices. Including {vatSymbol}."
msgstr "ยอดรวมของใบแจ้งหนี้ที่ยังไม่ได้ชำระทั้งหมด รวม {vatSymbol}"

#: src/styles/dataxion/theme.tsx
msgid "Total of all unpaid orders. Including VAT."
msgstr "ยอดรวมของคำสั่งซื้อที่ยังไม่ได้ชำระทั้งหมด รวมภาษีมูลค่าเพิ่มแล้ว"

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Transaction fee"
msgstr "ค่าธรรมเนียมธุรกรรม"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "Type"
msgstr "ประเภท"

#: src/modules/compute/labels.tsx
msgid "UEFI variables (NVRAM) will not persist across reboots."
msgstr "ตัวแปร UEFI (NVRAM) จะไม่คงอยู่หลังจากรีบูต"

#: src/modules/access/AccessList.tsx
msgid "UI"
msgstr "UI"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/UnAssignButton.tsx
msgid "Unassign"
msgstr "ยกเลิกการกำหนด"

#. State of IP address
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/UnassignedItem.tsx
msgid "Unassigned"
msgstr "ยังไม่ได้กำหนด"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Unit"
msgstr "หน่วย"

#. Label for an unknown item in a select control
#: src/components/EnumBadge.tsx
#: src/modules/billing/BillingAccountLink.tsx
#: src/modules/network/NetworkList.tsx
msgid "Unknown"
msgstr "ไม่ทราบ"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Unknown Auth0 error"
msgstr "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุจาก Auth0"

#: src/modules/access/scopeLabel.tsx
msgid "Unknown billing account"
msgstr "บัญชีการเรียกเก็บเงินที่ไม่รู้จัก"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Unknown payment error{codeSuffix}"
msgstr "ข้อผิดพลาดในการชำระเงินที่ไม่ทราบสาเหตุ{codeSuffix}"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/network/AssignToSelect.tsx
msgid "Unknown resource"
msgstr "ทรัพยากรที่ไม่รู้จัก"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Unlink target"
msgstr "ยกเลิกการเชื่อมโยงเป้าหมาย"

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Unpaid"
msgstr "ยังไม่ได้ชำระ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Unpaid amount"
msgstr "ยอดค้างชำระ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Unverified"
msgstr "ยังไม่ได้ยืนยัน"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update"
msgstr "อัปเดต"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update SSH key"
msgstr "อัปเดตกุญแจ SSH"

#. Button action to upload a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Upload"
msgstr "อัปโหลด"

#: src/styles/dataxion/theme.tsx
msgid "Upload a copy of only the RNE document for verification"
msgstr "อัปโหลดสำเนาเอกสาร RNE เท่านั้นเพื่อใช้ในการยืนยัน"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploading files"
msgstr "กำลังอัปโหลดไฟล์"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploads are still in progress. If you leave this page, progress will no longer be shown and uploads may be interrupted. Leave anyway?"
msgstr "การอัปโหลดยังอยู่ระหว่างดำเนินการ หากคุณออกจากหน้านี้ ความคืบหน้าจะไม่แสดงอีกต่อไป และการอัปโหลดอาจถูกขัดจังหวะ ต้องการออกจากหน้านี้หรือไม่?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Usage"
msgstr "การใช้งาน"

#: src/modules/compute/VmCreate.tsx
msgid "Use the ISO boot option after the virtual machine has been created to install an operating system yourself."
msgstr "ใช้ตัวเลือกบูตจาก ISO หลังจากสร้างเครื่องเสมือนแล้ว เพื่อติดตั้งระบบปฏิบัติการด้วยตนเอง"

#: src/modules/dashboard/UserAccess.tsx
msgid "User access"
msgstr "การเข้าถึงของผู้ใช้"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "User must accept access invitation from their profile view"
msgstr "ผู้ใช้ต้องยอมรับคำเชิญการเข้าถึงจากหน้าโปรไฟล์ของตน"

#. Link to regular user interface
#: src/modules/user/UserMenu.tsx
msgid "User view"
msgstr "มุมมองผู้ใช้"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "User's email"
msgstr "อีเมลของผู้ใช้"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Username"
msgstr "ชื่อผู้ใช้"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users I can access"
msgstr "ผู้ใช้ที่ฉันเข้าถึงได้"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users who can access my account"
msgstr "ผู้ใช้ที่สามารถเข้าถึงบัญชีของฉัน"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "UUID"
msgstr "UUID"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Valid thru"
msgstr "วันหมดอายุ"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Validation pending"
msgstr "การตรวจสอบกำลังรอดำเนินการ"

#: src/modules/compute/ParamsTextField.tsx
msgid "Value does not match required pattern"
msgstr "ค่าไม่ตรงตามรูปแบบที่กำหนด"

#: src/components/VatText.tsx
msgid "VAT"
msgstr "ภาษีมูลค่าเพิ่ม"

#: src/components/VatText.tsx
msgid "VAT number"
msgstr "เลขประจำตัวผู้เสียภาษีมูลค่าเพิ่ม"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MachineSizeInfo.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "vCPU"
msgstr "vCPU"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Verified"
msgstr "ยืนยันแล้ว"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Verified payment method is missing"
msgstr "ไม่มีวิธีการชำระเงินที่ยืนยันแล้ว"

#: src/modules/billing/progressLabels.tsx
msgid "Verifying payment method"
msgstr "กำลังตรวจสอบวิธีการชำระเงิน"

#: src/modules/compute/os/OsVersionSelect.tsx
#: src/modules/metal/os/MetalOsSelect.tsx
#: src/modules/services/os/OsVersionSelect.tsx
msgid "Version"
msgstr "เวอร์ชัน"

#. Button action
#: src/components/ResourceLink.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/notifications/toast.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "View"
msgstr "ดู"

#: src/components/table/WTable.tsx
msgid "View all records"
msgstr "ดูรายการทั้งหมด"

#: src/modules/compute/VmView.tsx
msgid "View config commands"
msgstr "ดูคำสั่งการตั้งค่า"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "View details"
msgstr "ดูรายละเอียด"

#: src/components/table/WTable.tsx
msgid "View last {limit} records"
msgstr "ดู {limit} รายการล่าสุด"

#: src/modules/user/InvitationNotice.tsx
msgid "View more"
msgstr "ดูเพิ่มเติม"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Virtual host style URL"
msgstr "URL แบบ Virtual host"

#: src/modules/api/resourceTypes.tsx
msgid "Virtual machine"
msgstr "เครื่องเสมือน"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "VLAN"
msgstr "VLAN"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
msgid "VLAN ID"
msgstr "รหัส VLAN"

#: src/modules/services/Networking.tsx
msgid "VPC IP range"
msgstr "ช่วง IP ของ VPC"

#: src/modules/compute/VmView.tsx
msgid "VPC name"
msgstr "ชื่อ VPC"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/VpcRow.tsx
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "VPC network"
msgstr "เครือข่าย VPC"

#: src/modules/network/NetworkCreate.tsx
msgid "VPC network is available at no additional cost."
msgstr "เครือข่าย VPC พร้อมให้ใช้งานโดยไม่มีค่าใช้จ่ายเพิ่มเติม"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Wait for verification or add card"
msgstr "รอการยืนยันหรือเพิ่มบัตร"

#: src/modules/billing/progressLabels.tsx
msgid "Waiting for payment confirmation"
msgstr "กำลังรอการยืนยันการชำระเงิน"

#: src/modules/billing/popup/popup.ts
msgid "Waiting for popup to return from redirect timed out"
msgstr "หมดเวลารอให้ป๊อปอัปกลับมาหลังจากการเปลี่ยนเส้นทาง"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Waking up"
msgstr "กำลังปลุกให้ทำงาน"

#: src/modules/access/AdminUserWarning.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Warning"
msgstr "คำเตือน"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Warning: It is recommended to stop the virtual machine before resizing the boot disk."
msgstr "คำเตือน: แนะนำให้หยุดเครื่องเสมือนก่อนปรับขนาดดิสก์บูต"

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "We recommend adding a credit card while your request is being processed to activate services right away."
msgstr "เราแนะนำให้เพิ่มบัตรเครดิตระหว่างที่คำขอของคุณกำลังอยู่ระหว่างการดำเนินการ เพื่อให้สามารถเปิดใช้งานบริการได้ทันที"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "We recommend automated top up as it minimizes the risk of running out of funds and thus affecting your server resources."
msgstr "เราแนะนำให้ใช้การเติมเงินอัตโนมัติ เนื่องจากช่วยลดความเสี่ยงที่ยอดเงินจะหมดและส่งผลกระทบต่อทรัพยากรเซิร์ฟเวอร์ของคุณ"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "We've assembled some links to get you started. Develop, test code, and deploy your applications in no time, from prototyping to large-scale development."
msgstr "เราได้รวบรวมลิงก์บางส่วนไว้เพื่อช่วยให้คุณเริ่มต้นใช้งานได้อย่างรวดเร็ว พัฒนา ทดสอบโค้ด และปรับใช้แอปพลิเคชันของคุณได้ในเวลาอันสั้น ตั้งแต่การสร้างต้นแบบไปจนถึงการพัฒนาขนาดใหญ่"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "We've reached the capacity of our file browser. In order to maintain the stability of our user interface, we've terminated the loading of your bucket contents. Please utilize external tools at your disposal to manage the content within your bucket"
msgstr "ตัวเรียกดูไฟล์ของเราได้ถึงขีดความสามารถสูงสุดแล้ว เพื่อรักษาเสถียรภาพของส่วนติดต่อผู้ใช้ เราจึงยุติการโหลดเนื้อหาในบัคเก็ตของคุณ โปรดใช้เครื่องมือภายนอกที่มีอยู่เพื่อจัดการเนื้อหาภายในบัคเก็ตของคุณ"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Welcome"
msgstr "ยินดีต้อนรับ"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Welcome!<0/>We're glad you're here."
msgstr "ยินดีต้อนรับ!<0/>เรายินดีที่คุณมาใช้งาน"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "What would you like to do?"
msgstr "คุณต้องการดำเนินการอย่างไร?"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "When balance goes below"
msgstr "เมื่อยอดคงเหลือต่ำกว่า"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "When reserved but not assigned to a resource IPv4 address will be charged for <0/> / month."
msgstr "เมื่อสำรองที่อยู่ IPv4 ไว้แต่ยังไม่ได้กำหนดให้กับทรัพยากร จะมีการเรียกเก็บค่าใช้จ่าย <0/> / เดือน"

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "When selected, a public floating IPv4 address will be created and assigned automatically to your resource. If you do not want to have public access to your resource you can unselect the option here or remove the IP address later."
msgstr "เมื่อเลือกตัวเลือกนี้ ระบบจะสร้างที่อยู่ IPv4 สาธารณะแบบไอพีลอยตัวและกำหนดให้กับทรัพยากรของคุณโดยอัตโนมัติ หากคุณไม่ต้องการให้ทรัพยากรของคุณเข้าถึงได้จากสาธารณะ คุณสามารถยกเลิกการเลือกตัวเลือกนี้ที่นี่ หรือนำที่อยู่ IP ออกภายหลังได้"

#: src/modules/compute/VmView.tsx
msgid "When you enable the backup service, an automatic disk-level backup will be created from the boot disk (excluding additional disks). A backup will be created once a week and will be listed here. You can later use the backup images to restore your virtual machine or create a new virtual machine with modified size parameters from the backup."
msgstr "เมื่อคุณเปิดใช้บริการสำรองข้อมูล ระบบจะสร้างข้อมูลสำรองอัตโนมัติในระดับดิสก์จากดิสก์บูต (ไม่รวมดิสก์เพิ่มเติม) โดยจะสร้างข้อมูลสำรองสัปดาห์ละครั้งและแสดงรายการไว้ที่นี่ ภายหลังคุณสามารถใช้อิมเมจสำรองข้อมูลเพื่อกู้คืนเครื่องเสมือนของคุณ หรือสร้างเครื่องเสมือนใหม่จากข้อมูลสำรองโดยปรับพารามิเตอร์ขนาดได้"

#: src/components/loading/Loading.tsx
msgid "While the job is in progress you can:"
msgstr "ในระหว่างที่งานกำลังดำเนินการ คุณสามารถ:"

#: src/modules/api/resourceTypes.tsx
msgid "With a firewall you can control incoming and outgoing network traffic based on predetermined security rules."
msgstr "ด้วยไฟร์วอลล์ คุณสามารถควบคุมทราฟฟิกเครือข่ายขาเข้าและขาออกตามกฎความปลอดภัยที่กำหนดไว้ล่วงหน้า"

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "With first billing account you will be able to unlock your complimentary free credit of <0><1/></0>."
msgstr "เมื่อสร้างบัญชีการเรียกเก็บเงินบัญชีแรก คุณจะสามารถปลดล็อกเครดิตฟรีมูลค่า <0><1/></0> ที่มอบให้ได้"

#. placeholder {0}: currency.title
#: src/modules/billing/ConversionMessage.tsx
msgid "With the selected payment method, you will be charged in {0}."
msgstr "เมื่อใช้วิธีการชำระเงินที่เลือก คุณจะถูกเรียกเก็บเงินเป็นสกุล {0}"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Without an active billing account you can not create any resources, create one to get started."
msgstr "หากไม่มีบัญชีการเรียกเก็บเงินที่ใช้งานอยู่ คุณจะไม่สามารถสร้างทรัพยากรใด ๆ ได้ โปรดสร้างบัญชีเพื่อเริ่มต้นใช้งาน"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Without an active billing account, resources can not be created."
msgstr "หากไม่มีบัญชีการเรียกเก็บเงินที่ใช้งานอยู่ จะไม่สามารถสร้างทรัพยากรได้"

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "year"
msgstr "ปี"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Yearly"
msgstr "รายปี"

#: src/modules/disks/disk/DiskView.tsx
msgid "Yes"
msgstr "ใช่"

#: src/modules/user/ActAsModal.tsx
msgid "You are about to access user \"{name}\""
msgstr "คุณกำลังจะเข้าถึงผู้ใช้ \"{name}\""

#: src/modules/access/AdminUserWarning.tsx
msgid "You are an administrator and are about to delegate your administrative privileges to another user. Please ensure this action is intentional."
msgstr "คุณเป็นผู้ดูแลระบบและกำลังจะมอบสิทธิ์ผู้ดูแลระบบของคุณให้แก่ผู้ใช้รายอื่น โปรดตรวจสอบให้แน่ใจว่าการดำเนินการนี้เป็นไปตามที่คุณตั้งใจ"

#: src/modules/user/ProfileView.tsx
msgid "You can activate multi-factor authentication for improved security. This works only for the username-password login method. For social login methods (Google etc.), it is usually possible to activate MFA on the third party side."
msgstr "คุณสามารถเปิดใช้การยืนยันตัวตนแบบหลายปัจจัยเพื่อเพิ่มความปลอดภัยได้ ฟังก์ชันนี้ใช้ได้เฉพาะกับการเข้าสู่ระบบด้วยชื่อผู้ใช้และรหัสผ่านเท่านั้น สำหรับวิธีการเข้าสู่ระบบผ่านบัญชีภายนอก (เช่น Google) โดยปกติแล้วสามารถเปิดใช้ MFA ได้จากฝั่งผู้ให้บริการภายนอก"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "You can boot your virtual machine from a special image for system recovery or to install a fresh operating system. When this mode is activated, a chosen image will be attached as a boot medium. You can then use the Terminal to access your machine. This boot mode is enabled only for the current launch. Next time this virtual machine is started it will follow the normal boot routine."
msgstr "คุณสามารถบูตเครื่องเสมือนจากอิมเมจพิเศษเพื่อกู้คืนระบบหรือติดตั้งระบบปฏิบัติการใหม่ได้ เมื่อเปิดใช้โหมดนี้ อิมเมจที่เลือกจะถูกแนบเป็นสื่อสำหรับบูต จากนั้นคุณสามารถใช้คอนโซลเพื่อเข้าถึงเครื่องของคุณได้ โหมดบูตนี้จะเปิดใช้สำหรับการเริ่มทำงานครั้งปัจจุบันเท่านั้น ในครั้งถัดไปที่เริ่มเครื่องเสมือนนี้ ระบบจะบูตตามขั้นตอนปกติ"

#: src/modules/billing/PaymentReturn.tsx
msgid "You can close this page."
msgstr "คุณสามารถปิดหน้านี้ได้"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "You can create multiple billing accounts, each linked to specific payment methods. This approach allows you to effectively separate and monitor expenses across different teams, departments, or projects."
msgstr "คุณสามารถสร้างบัญชีการเรียกเก็บเงินได้หลายบัญชี โดยแต่ละบัญชีเชื่อมโยงกับวิธีการชำระเงินที่กำหนดไว้ วิธีนี้ช่วยให้คุณแยกและติดตามค่าใช้จ่ายของแต่ละทีม แผนก หรือโครงการได้อย่างมีประสิทธิภาพ"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You can do this from here and continue it later by clicking the link in the email we send you."
msgstr "คุณสามารถดำเนินการจากที่นี่และกลับมาทำต่อภายหลังได้โดยคลิกลิงก์ในอีเมลที่เราส่งให้คุณ"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "You can earn and give free credits by sharing your unique referral code."
msgstr "คุณสามารถรับและมอบเครดิตฟรีได้โดยการแชร์รหัสแนะนำเฉพาะของคุณ"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "You cannot add another reservation because a future reservation already exists."
msgstr "คุณไม่สามารถเพิ่มการจองอื่นได้ เนื่องจากมีการจองในอนาคตอยู่แล้ว"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "You commit to the full price for the selected period as soon as you confirm the reservation."
msgstr "คุณตกลงชำระราคาเต็มจำนวนสำหรับระยะเวลาที่เลือกทันทีที่ยืนยันการจอง"

#. placeholder {0}: ipAddress.address
#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "You have a floating IP <0>{0}</0> assigned to this resource."
msgstr "คุณมีไอพีลอยตัว <0>{0}</0> ที่กำหนดให้กับทรัพยากรนี้"

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "You have an active campaign code (<0>{referralCode}</0>) pending to get additional bonus!"
msgstr "คุณมีโค้ดแคมเปญที่ใช้งานอยู่ (<0>{referralCode}</0>) ซึ่งรอรับโบนัสเพิ่มเติม!"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have billing account validation in progress."
msgstr "คุณมีการยืนยันบัญชีการเรียกเก็บเงินที่กำลังดำเนินการอยู่"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have completed billing account validation process. Please wait for the final decision."
msgstr "คุณได้ดำเนินการยืนยันบัญชีการเรียกเก็บเงินเสร็จสิ้นแล้ว โปรดรอผลการพิจารณาขั้นสุดท้าย"

#: src/modules/notifications/NotificationMenu.tsx
msgid "You have no notifications."
msgstr "คุณไม่มีการแจ้งเตือน"

#: src/modules/billing/QrCodeDisplay.tsx
msgid "You may close this dialog after you have made a payment."
msgstr "คุณสามารถปิดกล่องโต้ตอบนี้ได้หลังจากชำระเงินแล้ว"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "You may close this dialog window for now."
msgstr "คุณสามารถปิดหน้าต่างนี้ไปก่อนได้"

#: src/modules/storage/bucket/BucketView.tsx
msgid "You need to have at least one access key for browsing files in this bucket."
msgstr "คุณต้องมีคีย์การเข้าถึงอย่างน้อยหนึ่งคีย์เพื่อเรียกดูไฟล์ในบัคเก็ตนี้"

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is approved."
msgstr "คุณจะสามารถตั้งค่าวิธีการชำระเงินและใช้งานบริการคลาวด์ได้เมื่อการตรวจสอบได้รับอนุมัติ"

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is complete."
msgstr "คุณจะสามารถตั้งค่าวิธีการชำระเงินและใช้งานบริการคลาวด์ได้เมื่อการตรวจสอบเสร็จสมบูรณ์"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "You will not be charged until it is ready."
msgstr "คุณจะยังไม่ถูกเรียกเก็บเงินจนกว่าจะพร้อมใช้งาน"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Your account has been suspended"
msgstr "บัญชีของคุณถูกระงับ"

#: src/modules/billing/ConversionMessage.tsx
msgid "Your actual charge will be <0/>, with exchange rate of <1/>."
msgstr "ยอดเรียกเก็บเงินจริงของคุณจะเป็น <0/> โดยใช้อัตราแลกเปลี่ยน <1/>"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account has been suspended. See billing account details for more information and <0>contact support</0> to resolve the issue."
msgstr "บัญชีการเรียกเก็บเงินของคุณถูกระงับแล้ว ดูรายละเอียดบัญชีการเรียกเก็บเงินสำหรับข้อมูลเพิ่มเติม และ<0>ติดต่อฝ่ายสนับสนุน</0>เพื่อแก้ไขปัญหา"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Your billing account has been topped up"
msgstr "บัญชีการเรียกเก็บเงินของคุณได้รับการเติมเงินแล้ว"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account must have positive balance to get activated."
msgstr "บัญชีการเรียกเก็บเงินของคุณต้องมียอดคงเหลือมากกว่า 0 จึงจะเปิดใช้งานได้"

#: src/modules/login/Login.tsx
msgid "Your email address has been successfully verified. You can now log in."
msgstr "ยืนยันที่อยู่อีเมลของคุณเรียบร้อยแล้ว ตอนนี้คุณสามารถเข้าสู่ระบบได้"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Your email address has changed since you started validation. Please start over."
msgstr "ที่อยู่อีเมลของคุณมีการเปลี่ยนแปลงนับตั้งแต่เริ่มการยืนยัน โปรดเริ่มใหม่อีกครั้ง"

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Your selected billing account has {discount}% discount"
msgstr "บัญชีการเรียกเก็บเงินที่คุณเลือกมีส่วนลด {discount}%"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Your storage bucket contains a substantial number of files, and we've temporarily halted the loading process. Simply click the \"Load More\" button to continue loading the next batch of files."
msgstr "บัคเก็ตจัดเก็บข้อมูลของคุณมีไฟล์จำนวนมาก และเราได้หยุดกระบวนการโหลดไว้ชั่วคราว เพียงคลิกปุ่ม \"โหลดเพิ่มเติม\" เพื่อโหลดไฟล์ชุดถัดไปต่อ"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Zip/postal code"
msgstr "รหัสไปรษณีย์"
